import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const ARGB = (hex) => hex.replace("#", "").toUpperCase().padStart(8, "F");
const COLORS = {
  CR: ARGB("#1F4E78"),
  GR: ARGB("#595959"),
  FH: ARGB("#C00000"),
  MAG: ARGB("#9DC3E6"),
  HR: ARGB("#FFD966"),
  GANIL: ARGB("#F4B183"),
  TOTAL: ARGB("#D9D9D9"),
  WHITE: "FFFFFFFF",
  BLACK: "FF000000",
};

const HEADERS_RB = {
  CR: [
    "Tip",
    "Tür Detay",
    "Kalınlık (mm)",
    "Genişlik(mm)",
    "Kalite",
    "Adet",
    "Miktar",
    "Yaslanma",
    "CARİ ÜNVAN",
  ],
  GR: [
    "Tip",
    "Tür Detay",
    "Kalınlık (mm)",
    "Genişlik(mm)",
    "Kalite",
    "Adet",
    "Kaplama",
    "Miktar",
    "Yaslanma",

    "CARİ ÜNVAN",
  ],
  FH: [
    "Tip",
    "Tür Detay",
    "Kalınlık (mm)",
    "Genişlik(mm)",
    "Kalite",
    "Adet",
    "Miktar",
    "Görünüm 3",
    "Görünüm",
    "Yaslanma",

    "CARİ ÜNVAN",
  ],
  MAG: [
    "Tip",
    "Tür Detay",
    "Kalınlık (mm)",
    "Genişlik(mm)",
    "Kalite",
    "Adet",
    "Kaplama",
    "Miktar",
    "Yaslanma",

    "CARİ ÜNVAN",
  ],
  HR: [
    "Tip",
    "Tür",
    "Kalınlık",
    "Genişlik",
    "Kalite",
    "Adet",
    "Miktar",
    "Yaslanma",

    "CARİ ÜNVAN",
  ],
  GANIL: [
    "Tip",
    "Tür",
    "Kalınlık",
    "Genişlik",
    "Kalite",
    "Adet",
    "Kaplama",
    "Miktar",
    "Yaslanma",

    "CARİ ÜNVAN",
  ],
};
const HEADERS_BP_STOK = [
  "Tip",
  "Kalınlık",
  "Ebat",
  "Kalite",
  "Boy",
  "Kg",
  "Adet",
  "Kaplama",
  "Görünüm",
  "Yaslanma",

  "CARİ ÜNVAN",
];

function applyHeaderThick(ws, headerRow, totalCols) {
  for (let col = 1; col <= totalCols; col++) {
    const cell = ws.getCell(headerRow, col);
    cell.border = {
      top: { style: "thick" },
      left: { style: "thick" },
      right: { style: "thick" },
      bottom: { style: "thick" },
    };
  }
}

// DATA: sağ-sol thick, üst-alt thin
function applyDataSideBorders(ws, startRow, endRow, totalCols) {
  for (let row = startRow; row <= endRow; row++) {
    const isEmptyRow = Array.from({ length: totalCols }, (_, idx) => {
      const value = ws.getCell(row, idx + 1).value;

      if (value === null || value === undefined) return false;
      if (typeof value === "string") return value.trim() !== "";
      return true;
    }).every((hasValue) => !hasValue);

    for (let col = 1; col <= totalCols; col++) {
      const cell = ws.getCell(row, col);

      if (isEmptyRow) {
        cell.border = {};
        continue;
      }

      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thick" },
        right: { style: "thick" },
      };
    }
  }
}

function applyGlobalFont(ws) {
  ws.eachRow({ includeEmpty: true }, (row) => {
    row.eachCell((cell) => {
      cell.font = {
        ...(cell.font || {}),
        name: "Arial",
        bold: true, // tüm yazılar bold
      };
    });
  });
}

function applyGlobalFontForGenel(ws) {
  ws.eachRow({ includeEmpty: true }, (row) => {
    row.eachCell((cell) => {
      cell.font = {
        ...(cell.font || {}),
        name: "Arial",
      };
    });
  });
}

// Css Rezervesi stok analiz tablosu hariç hepsine uygulayacağız.
function applyDefaultSize(ws) {
  ws.eachRow({ includeEmpty: true }, (row) => {
    row.height = 20;
  });

  ws.columns.forEach((col) => {
    col.width = 17;

    const header =
      col.values && col.values[1] ? col.values[1].toString().toUpperCase() : "";

    if (
      header.includes("CARİ") ||
      header.includes("CARI") ||
      header.includes("CARİ ÜNVAN") ||
      header.includes("CARI UNVAN") ||
      header.includes("CARI ÜNVANI") ||
      header.includes("CARI UNVANI") ||
      header.includes("ÜNVAN") ||
      header.includes("UNVAN")
    ) {
      col.width = 60;
    }
  });
}
function applyDefaultSizeStok(ws) {
  // Tüm satırlar 30 px
  ws.eachRow({ includeEmpty: true }, (row) => {
    row.height = 30;
  });

  // Tüm kolonlar 25 px
  const totalCols = ws.columnCount;
  for (let c = 1; c <= totalCols; c++) {
    ws.getColumn(c).width = 25;
  }
}

function setColumnWidthsByHeaders(ws, headers, width, headerRow = 1) {
  const targets = headers.map((h) => h.toString().trim().toUpperCase());

  for (let col = 1; col <= ws.columnCount; col++) {
    const cellValue = ws.getCell(headerRow, col).value;
    const normalizedValue = (cellValue || "").toString().trim().toUpperCase();

    if (targets.includes(normalizedValue)) {
      ws.getColumn(col).width = width;
    }
  }
}

// sayfa renk, yazı tipi, kenarlık vs.
const setHeaderStyle = (row, bg, font = COLORS.WHITE) => {
  row.eachCell((c) => {
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    c.font = { bold: true, color: { argb: font } };
    c.alignment = { horizontal: "center", vertical: "middle" };
    c.border = {
      top: { style: "thick", color: { argb: COLORS.BLACK } },
      left: { style: "thick", color: { argb: COLORS.BLACK } },
      bottom: { style: "thick", color: { argb: COLORS.BLACK } },
      right: { style: "thick", color: { argb: COLORS.BLACK } },
    };
  });
};

const num = (v) =>
  (typeof v === "number" ? v : parseFloat(String(v).replace(",", "."))) || 0;
const autosize = (ws) =>
  ws.columns.forEach((col) => {
    let max = 10;
    col.eachCell({ includeEmpty: true }, (c) => {
      const len = (c.value ? String(c.value) : "").length;
      if (len > max) max = len;
    });
    col.width = Math.min(Math.max(max + 2, 12), 50);
  });

function autosizeSmart(ws) {
  const maxWidths = {
    1: 8, // Tip
    2: 12, // Tür Detay
    3: 10, // Kalınlık
    4: 10, // Genişlik
    5: 12, // Kalite
    6: 11, // Miktar
    7: 51, // Görünüm 3
    8: 60, // CARİ ÜNVAN
  };

  ws.columns.forEach((column, idx) => {
    let maxLength = 6;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? cell.value.toString().trim() : "";
      const len = val.length;
      if (len > maxLength) maxLength = len;
    });
    // sınırlı ayar: her kolon için sabit tavan
    const limit = maxWidths[idx + 1] || 15;
    column.width = Math.min(Math.max(maxLength + 2, 8), limit);
  });
}

function autosizeSmartBP(ws) {
  const maxWidths = {
    1: 8, // Tip
    2: 10, // Kalınlık
    3: 12, // Ebat
    4: 12, // Kalite
    5: 10, // Boy
    6: 12, // Kg
    7: 10, // Adet
    8: 12, // Kaplama
    9: 40, // Görünüm
    10: 40, // Görünüm 3
    11: 60, // CARİ ÜNVAN
  };

  ws.columns.forEach((column, idx) => {
    let maxLength = 6;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? String(cell.value).trim() : "";
      if (val.length > maxLength) maxLength = val.length;
    });
    const limit = maxWidths[idx + 1] ?? 15;
    column.width = Math.min(Math.max(maxLength + 2, 8), limit);
  });
}

// satır mapleme
const mapRowToHeaders_RB = (hdr, r, tip) => {
  const b = {
    Tip: tip,
    Tür: r["Tür"] ?? "",
    "Tür Detay": r["Tür Detay"] ?? r["Tür"] ?? "",
    "Kalınlık (mm)": r["Kalınlık"] ?? "",
    Kalınlık: r["Kalınlık"] ?? "",
    "Genişlik(mm)": r["Genişlik"] ?? "",
    Genişlik: r["Genişlik"] ?? "",
    Kalite: r["Kalite"] ?? "",
    Adet: r["Adet"] ?? r["ADET"] ?? 0,
    Kaplama: r["Kaplama"] ?? "",
    Miktar: r["ToplamKg"] ?? r["Miktar"] ?? r["Kg"] ?? "",
    "Miktar 1": r["ToplamKg"] ?? r["Miktar"] ?? r["Kg"] ?? "",
    Yaslanma: r["Yaslanma"] ?? "",
    "Görünüm 3":
      r["Görünüm 3"] ?? r["Gorunum3"] ?? r["gorunum3"] ?? r["GORUNUM3"] ?? "",
    Görünüm: r["Görünüm"] ?? r["Gorunum"] ?? r["gorunum"] ?? r["GORUNUM"] ?? "",
    "CARİ ÜNVAN": r["Cari Ünvanı"] ?? r["Cari"] ?? "",
  };

  return hdr.map((h) => b[h] ?? "");
};
const mapRowToHeaders_BP_Stok = (r) => {
  const b = {
    Tip: "BP",
    Kalınlık: r["Kalınlık"] ?? "",
    Ebat: r["Ebat"] ?? r["Genişlik"] ?? "",
    Kalite: r["Kalite"] ?? "",
    Boy: r["Boy"] ?? "",
    Kg: r["ToplamKg"] ?? "",
    Adet: r["ToplamAdet"] ?? "",
    Kaplama: r["Kaplama"] ?? "",
    Görünüm: r["Gorunum"] ?? "",
    Yaslanma: r["Yaslanma"] ?? "",
    "CARİ ÜNVAN": r["Cari Ünvanı"] ?? "",
  };
  return HEADERS_BP_STOK.map((h) => b[h] ?? "");
};

const buildTotalRowByHeader = (headers, total, label = "GENEL TOPLAM") => {
  const row = Array(headers.length).fill("");
  row[0] = label;

  const totalColIndex = headers.findIndex((header) => {
    const normalized = String(header).trim().toUpperCase();
    return normalized === "MIKTAR" || normalized === "KG";
  });

  if (totalColIndex !== -1) {
    row[totalColIndex] = total;
  } else if (headers.length > 1) {
    row[headers.length - 1] = total;
  }

  return row;
};

// ========== Kalın Çerceve functionu yeni geldi 14.11.2025 ==========
function setFullBorder(ws) {
  ws.eachRow({ includeEmpty: true }, (row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });
  });
}

const setCellStyle = (ws) => {
  ws.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };

      cell.alignment = {
        horizontal: "center", //  Yatay ortalama
        vertical: "middle", //  Dikey ortalama
        wrapText: true, //  Uzun metinleri satıra sardır
      };
    });
  });
};

// ==========================================================
// HAMMADDE-ÜRETİM ANALİZ AY ARALIĞI
// Şimdilik seçilebilir aylar sabit: OCAK 2026 → NİSAN 2027.
// Aralığı genişletmek için sadece HU_AY_ARALIK'ı değiştirmek yeterli.
// ==========================================================
export const HU_AY_ADLARI = [
  "OCAK", "ŞUBAT", "MART", "NİSAN", "MAYIS", "HAZİRAN",
  "TEMMUZ", "AĞUSTOS", "EYLÜL", "EKİM", "KASIM", "ARALIK",
];
export const HU_AY_ARALIK = { min: "2026-01", max: "2027-04" };

// "2026-02" → ay indeksi (yıl*12 + ay)
const ayKeyToIdx = (key) => {
  const m = /^(\d{4})-(\d{1,2})$/.exec(String(key || "").trim());
  return m ? Number(m[1]) * 12 + (Number(m[2]) - 1) : null;
};
const idxToAyKey = (idx) =>
  `${Math.floor(idx / 12)}-${String((idx % 12) + 1).padStart(2, "0")}`;
const ayIdxLabel = (idx) => `${HU_AY_ADLARI[idx % 12]} ${Math.floor(idx / 12)}`;
const buAyIdx = () => {
  const now = new Date();
  return now.getFullYear() * 12 + now.getMonth();
};

// Seçim kutuları için ay listesi
export const getHammaddeUretimAyOptions = () => {
  const min = ayKeyToIdx(HU_AY_ARALIK.min);
  const max = ayKeyToIdx(HU_AY_ARALIK.max);
  const cur = buAyIdx();
  const list = [];
  for (let i = min; i <= max; i++) {
    list.push({ value: idxToAyKey(i), label: ayIdxLabel(i), gecmis: i < cur });
  }
  return list;
};

// Varsayılan: içinde bulunulan ay → aralığın son ayı
export const getVarsayilanAyAraligi = () => {
  const min = ayKeyToIdx(HU_AY_ARALIK.min);
  const max = ayKeyToIdx(HU_AY_ARALIK.max);
  const cur = Math.max(min, Math.min(max, buAyIdx()));
  return { baslangic: idxToAyKey(cur), bitis: HU_AY_ARALIK.max };
};

export async function exportAllToExcel(
  rulo = [],
  band = [],
  profil = [],
  hammadde = [],
  options = {}
) {
  const wb = new ExcelJS.Workbook();
  // sadece Tür Detay'a göre filtrele
  const filterBy = (arr, key) => {
    const keys = Array.isArray(key) ? key : [key];

    return arr.filter((x) => {
      const tur = (x?.["Tür Detay"] || x?.["Tür"] || "").toUpperCase();
      return keys.some((k) => tur === k.toUpperCase());
    });
  };

  // RULO ve BAND filtreleri
  const rCR = filterBy(rulo, "SOĞUK");
  const rGR = filterBy(rulo, "GALVANİZ");
  const rFH = filterBy(rulo, "FULLHARD");
  const rMAG = filterBy(rulo, "MAGNELİS");
  const rHR = filterBy(rulo, "SICAK");
  const rGAN = filterBy(rulo, "GALVANİL");

  const bCR = filterBy(band, "SOĞUK");
  const bGR = filterBy(band, "GALVANİZ");
  const bFH = filterBy(band, "FULLHARD");
  const bMAG = filterBy(band, "MAGNELİS");
  const bHR = filterBy(band, ["SICAK", "ASİTLİ"]);
  const bGAN = filterBy(band, "GALVANİL");

  // Profil
  const filterStok = (arr, key) =>
    arr.filter(
      (x) =>
        (x?.["Cari Ünvanı"] || "") === "--1. KALİTE ÜRETİM STOK--" &&
        (x?.["Tür Detay"] || x?.["Tür"] || "").toUpperCase() ===
          key.toUpperCase()
    );
  const pCR_STOK = filterStok(profil, "SOĞUK");
  const pGR_STOK = filterStok(profil, "GALVANİZ");
  const pHR_STOK = filterStok(profil, "SICAK");

  const filterOps = (arr, key) =>
    arr.filter(
      (x) =>
        (x?.["Cari Ünvanı"] || "") !== "--1. KALİTE ÜRETİM STOK--" &&
        (x?.["Tür Detay"] || x?.["Tür"] || "").toUpperCase() ===
          key.toUpperCase()
    );
  const pCR_OPS = filterOps(profil, "SOĞUK");
  const pGR_OPS = filterOps(profil, "GALVANİZ");
  const pHR_OPS = filterOps(profil, "SICAK");

  function groupRB(rows) {
    const map = new Map();

    rows.forEach((r) => {
      const key = [
        r["Tip"] ?? "",
        r["Tür Detay"] ?? "",
        r["Kalınlık"] ?? "",
        r["Genişlik"] ?? "",
        r["Kalite"] ?? "",
        r["Yaslanma"] ?? "",
        r["Cari Ünvanı"] ?? "",
        r["StokYeri"] ?? "", // Grouping'de kaybolmasın diye buraya eklemek gerekebilir ama mevcut yapıyı bozmuyoruz.
      ].join("||");

      if (!map.has(key)) {
        // ilk kayıt
        map.set(key, {
          ...r,
          Adet: Number(r["Adet"] || 0),
          Miktar: Number(r["Miktar"] || 0),
          ToplamKg: Number(r["ToplamKg"] || r["Miktar"] || 0),
        });
      } else {
        const exist = map.get(key);

        // → ADET
        exist.Adet += Number(r["Adet"] || 0);

        // → MİKTAR (sadece Miktar toplanır)
        exist.Miktar += Number(r["Miktar"] || 0);

        // → ToplamKg (ToplamKg varsa onu, yoksa Miktar'ı topla)
        exist.ToplamKg += Number(r["ToplamKg"] || r["Miktar"] || 0);

        map.set(key, exist);
      }
    });

    return Array.from(map.values());
  }

  // Excel sayfa oluşturma fonksiyonları
  // NOT: normalizeText ve num fonksiyonları dışarıda tanımlı olmalı.
  //      createRB içinde direkt kullanıyoruz.

  const createRB = (title, color, rows, tip, key) => {
    const normalizeText = (val = "") =>
      val
        .toString()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[().,-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    if (title === "FH BAND STOK") {
      rows = rows.map((r) => {
        const kal = Number(String(r["Kalınlık"]).replace(",", "."));
        const cariNorm = normalizeText(r["Cari Ünvanı"]);
        const hedef = "1 KALITE URETIM STOK";

        const isDeneme = kal <= 0.53 && cariNorm === hedef;

        return {
          ...r,
          "Cari Ünvanı": isDeneme ? "DENEME ÜRETİM" : r["Cari Ünvanı"],
          //değiştirdim  ["Cari Ünvanı"]: isDeneme ? "DENEME ÜRETİM" : r["Cari Ünvanı"],
        };
      });
    }

    // ============================================================

    if (!title.includes("BP")) {
      rows = groupRB(rows);
    }

    const ws = wb.addWorksheet(title.substring(0, 31));
    ws.properties.tabColor = { argb: color };

    const hdr = HEADERS_RB[key];
    ws.addRow(hdr);
    setHeaderStyle(ws.getRow(1), color, COLORS.WHITE);

    if (!rows.length) {
      ws.addRow([""]);
      autosize(ws);
      applyGlobalFont(ws);
      return;
    }

    rows.sort((a, b) => num(b["Kalınlık"]) - num(a["Kalınlık"]));

    rows.forEach((r) => {
      const rowCopy = { ...r };
      const addedRow = ws.addRow(mapRowToHeaders_RB(hdr, rowCopy, tip));

      // --- KARANTİNA DEPO GÖRSEL AYRIMI ---
      if (rowCopy["StokYeri"] === "KARANTİNA DEPO") {
        addedRow.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFF00" }, // Sarı dolgu
          };
        });
      }
      // ------------------------------------
    });

    // GENEL TOPLAM
    const total = rows.reduce((s, r) => s + num(r.ToplamKg), 0);

    const tr = ws.addRow(buildTotalRowByHeader(hdr, total));

    tr.font = { bold: true };
    tr.eachCell((c) => {
      c.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: COLORS.TOTAL },
      };
    });

    autosize(ws);
    setCellStyle(ws);
    applyHeaderThick(ws, 1, hdr.length);
    applyDataSideBorders(ws, 2, ws.lastRow.number, hdr.length);
    applyDefaultSize(ws);
    if (title === "FH BAND STOK") {
      setColumnWidthsByHeaders(ws, ["Görünüm 3", "Görünüm"], 36);
    }
    if (
      [
        "CR RULO STOK",
        "CR BAND STOK",
        "GR RULO STOK",
        "GR BAND STOK",
      ].includes(title)
    ) {
      setColumnWidthsByHeaders(ws, ["CARİ ÜNVAN"], 100);
    }
    applyGlobalFont(ws);
  };

  const createBPOps = (title, color, rows) => {
    const ws = wb.addWorksheet(title.substring(0, 31));
    ws.properties.tabColor = { argb: color };

    //  Headerları aynen BP_STOK formatında yapıyoruz
    ws.addRow(HEADERS_BP_STOK);
    setHeaderStyle(ws.getRow(1), color, COLORS.WHITE);

    if (!rows.length) {
      ws.addRow([""]);
      autosize(ws);
      applyGlobalFont(ws);

      return;
    }

    //  Tür filtreleme (CR → SOĞUK, GR → GALVANİZ, HR → SICAK)
    let filterKey = "";
    if (title.includes("CR")) filterKey = "SOĞUK";
    else if (title.includes("GR")) filterKey = "GALVANİZ";
    else if (title.includes("HR")) filterKey = "SICAK";

    const filtered = filterKey
      ? rows.filter((r) =>
          (r["Tür Detay"] || r["Tür"] || "")
            .toUpperCase()
            .includes(filterKey.toUpperCase())
        )
      : rows;

    //  Kalınlığa göre sırala
    filtered.sort((a, b) => num(b["Kalınlık"]) - num(a["Kalınlık"]));

    //  Satırları yaz
    filtered.forEach((r) => {
      const addedRow = ws.addRow(mapRowToHeaders_BP_Stok(r));

      // --- KARANTİNA DEPO GÖRSEL AYRIMI ---
      if (r["StokYeri"] === "KARANTİNA DEPO") {
        addedRow.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFF00" }, // Sarı dolgu
          };
        });
      }
      // ------------------------------------
    });

    //  Genel toplam satırı
    const total = filtered.reduce((s, r) => s + num(r.ToplamKg), 0);
    const tr = ws.addRow(["GENEL TOPLAM", "", "", "", "", total, "", "", ""]);
    tr.font = { bold: true };
    tr.eachCell(
      (c) =>
        (c.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: COLORS.TOTAL },
        })
    );
    autosize(ws);
    setCellStyle(ws);
    applyHeaderThick(ws, 1, HEADERS_BP_STOK.length);
    applyDataSideBorders(ws, 2, ws.lastRow.number, HEADERS_BP_STOK.length);
    applyDefaultSize(ws);
    setColumnWidthsByHeaders(ws, ["Tip"], 21);
    const isCrOps = title === "CR OPSİYON BP";
    setColumnWidthsByHeaders(ws, ["Görünüm"], isCrOps ? 55 : 41);
    setColumnWidthsByHeaders(ws, ["CARİ ÜNVAN"], isCrOps ? 100 : 60);
    applyGlobalFont(ws);
  };

  const createFHRuloSheets = () => {
    const headers = [
      "Tip",
      "Tür Detay",
      "Kalınlık (mm)",
      "Genişlik(mm)",
      "Kalite",
      "Adet",
      "Miktar",
      "Görünüm 3",
      "Yaşlanma",
      "CARİ ÜNVAN",
    ];

    const highlightPhrases = [
      "B/P İÇİN UYGUN DEĞİL",
      "KALINLIK DEĞİŞİMİ-DİLME AYRILACAK",
      "BOYKESİM İÇİN UYGUN",
      "NİKEL KAPLAMA PARLAK YÜZEY ONAY ALINMADAN DİLİNMESİN",
      "TAV YANIĞI (MENEVİŞ RENK)",
      "KALINLIK FARKI VAR",
      "BOHCA",
      "EK VAR",
      "BOYALI",
      "BOHÇA",
      "BOHÇA-BOYKESİM İÇİN UYGUN",
      "BOY KESİM İÇİN UYGUN",
      "İÇ-DIŞ SARIM KAL.FARKI",
    ];

    const makeSheet = (sheetName, filterFn, titles) => {
      const [unusableTitle, usableTitle] = titles;

      const ws = wb.addWorksheet(sheetName);
      ws.properties.tabColor = { argb: COLORS.FH };
      ws.addRow(headers);
      setHeaderStyle(ws.getRow(1), COLORS.FH, COLORS.WHITE);

      const filtered = rFH.filter(filterFn);

      const unusable = filtered.filter((r) => {
        const g3 = (r.Gorunum3 || "").toUpperCase();
        return highlightPhrases.some((p) => g3.includes(p));
      });

      const usable = filtered.filter((r) => {
        const g3 = (r.Gorunum3 || "").toUpperCase();
        return !highlightPhrases.some((p) => g3.includes(p));
      });

      const writeSection = (title, data) => {
        ws.addRow([]);
        const titleRow = ws.addRow([title]);
        const colorEndCol = 9;

        for (let col = 1; col <= colorEndCol; col++) {
          const cell = ws.getCell(titleRow.number, col);
          if (col === 1) cell.value = title;
          cell.font = { bold: true, color: { argb: COLORS.WHITE }, size: 12 };
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.FH },
          };
        }

        // 🧹 H’den sonrası temiz
        for (let col = colorEndCol + 1; col <= headers.length; col++) {
          const cell = ws.getCell(titleRow.number, col);
          cell.fill = { type: "pattern", pattern: "none" };
          cell.value = "";
        }

        ws.mergeCells(titleRow.number, 1, titleRow.number, colorEndCol);

        if (!data.length) {
          const emptyRow = ws.addRow(buildTotalRowByHeader(headers, 0));
          emptyRow.font = { bold: true };
          emptyRow.eachCell((c) => {
            c.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: COLORS.TOTAL },
            };
          });
          return;
        }

        data.sort((a, b) => num(a.Kalınlık) - num(b.Kalınlık));

        data.forEach((r) => {
          const row = ws.addRow([
            "RULO",
            r["Tür"] ?? "",
            r["Kalınlık"] ?? "",
            r["Genişlik"] ?? "",
            r["Kalite"] ?? "",
            r["Adet"] ?? "",
            r["ToplamKg"] ?? "",
            r["Gorunum3"] ?? "",
            r["Yaslanma"] ?? "",
            r["Cari Ünvanı"] ?? "",
          ]);

          if (
            title.includes("0.54 MM VE ÜSTÜNDEKİ KALINLIKTA KULLANILABİLİR")
          ) {
            const kalinlik = parseFloat(
              String(r["Kalınlık"]).replace(",", ".")
            );
            if (kalinlik >= 0.54 && kalinlik <= 1.2) {
              row.eachCell((cell) => {
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "C6EFCE" }, // açık yeşil
                };
                cell.font = { color: { argb: "006100" } }; // koyu yeşil yazı
              });
            } else if (kalinlik > 1.2) {
              row.eachCell((cell) => {
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "FFC7CE" }, // açık kırmızı
                };
                cell.font = { color: { argb: "9C0006" } }; // koyu kırmızı yazı
              });
            }
          }

          const g3 = (r.Gorunum3 || "").toUpperCase();
          if (highlightPhrases.some((p) => g3.includes(p))) {
            row.eachCell((cell) => {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "E6B8FF" }, // açık mor
              };
            });
          }

          // --- KARANTİNA DEPO GÖRSEL AYRIMI ---
          // Burada diğer renklendirmelerin üzerine basmaması için en sona ekledik veya duruma göre öncelik veriyoruz.
          // Sarı yapmak istediğimiz için, mevcut renklerin üzerine sarı basacağız.
          if (r["StokYeri"] === "KARANTİNA DEPO") {
            row.eachCell((cell) => {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" }, // Sarı dolgu
              };
            });
          }
          // ------------------------------------
        });

        const total = data.reduce((sum, r) => sum + num(r.ToplamKg), 0);
        const totalRow = ws.addRow(buildTotalRowByHeader(headers, total));
        totalRow.font = { bold: true };
        for (let col = 1; col <= 8; col++) {
          const cell = totalRow.getCell(col);
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.TOTAL },
          };
        }
      };

      writeSection(unusableTitle, unusable);
      writeSection(usableTitle, usable);

      // 📏 Otomatik ayarlar
      autosizeSmart(ws);
      setCellStyle(ws);
      setFullBorder(ws);
      applyDefaultSize(ws);
      setColumnWidthsByHeaders(ws, ["Görünüm 3"], 51);
      applyGlobalFont(ws);

      ws.eachRow((row, rowNumber) => {
        const titleCell = (row.getCell(1).value || "").toString();

        // 💜 Mor renklendirilecek başlıklar
        const morBasliklar = [
          "0.53 MM VE ALTINDAKİ KALINLIKTA RULO KAYNAKLI KULLANILAMAZ RULOLAR",
          "0.53 MM VE ALTINDAKİ KALINLIKTA MAKİNA KAYNAKLI KULLANILAMAZ RULOLAR",
          "0.54 MM VE ÜSTÜNDEKİ KALINLIKTA KULLANILAMAZ RULOLAR",
        ];

        if (morBasliklar.includes(titleCell)) {
          const start = rowNumber + 1;
          const end = ws.lastRow.number;

          for (let i = start; i <= end; i++) {
            const r = ws.getRow(i);
            const firstCell = (r.getCell(1).value || "").toString();

            // "GENEL TOPLAM" satırına kadar mor yap
            if (firstCell.includes("GENEL TOPLAM")) break;

            r.eachCell((cell) => {
              // Eğer satır Karantina ise sarıyı koru, değilse mor yap
              // Ancak burada mor blok komple boyandığı için, karantina kontrolünü tekrar yapıp üstüne basmak daha güvenli.
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "7030A0" }, // 💜 Mor arka plan
              };
              cell.font = {
                color: { argb: "FFFFFF" }, // ⚪ Beyaz yazı
                bold: true,
              };
            });
          }
        }
      });
    };

    // 📄 Sayfaları oluştur
    makeSheet("FH 0,53 MM ALTI RULO STOK", (r) => num(r.Kalınlık) <= 0.53, [
      "0.53 MM VE ALTINDAKİ KALINLIKTA RULO KAYNAKLI KULLANILAMAZ RULOLAR",
      "0.53 MM VE ALTINDAKİ KALINLIKTA MAKİNA KAYNAKLI KULLANILAMAZ RULOLAR",
    ]);

    makeSheet("FH 0,54 MM ÜSTÜ RULO STOK", (r) => num(r.Kalınlık) >= 0.54, [
      "0.54 MM VE ÜSTÜNDEKİ KALINLIKTA KULLANILAMAZ RULOLAR",
      "0.54 MM VE ÜSTÜNDEKİ KALINLIKTA KULLANILABİLİR RULOLAR",
    ]);
  };

  function createBPStokGrouped(title, color, rows) {
    const ws = wb.addWorksheet(title.substring(0, 31));
    ws.properties.tabColor = { argb: color };
    ws.addRow(HEADERS_BP_STOK);
    setHeaderStyle(ws.getRow(1), color, COLORS.WHITE);

    // ============================================
    // NORMALIZE (buildStokOzetFromRaw ile BİREBİR AYNI)
    // ============================================
    const normalizeText = (val = "") =>
      val
        .toString()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[().,-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const cleanG = (v = "") =>
      v
        .toString()
        .normalize("NFC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\u00A0/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const num = (v) => parseFloat(String(v).replace(",", ".")) || 0;

    // ============================================
    // 1. KALİTE ÜRETİM STOK filtresi (Aynı yapı)
    // ============================================
    const data = rows.filter((r) => {
      const raw = r["Cari Ünvanı"] || "";
      const cari = normalizeText(raw);
      return cari.includes("1 KALITE URETIM STOK");
    });

    if (!data.length) {
      ws.addRow(["VERİ YOK"]);
      return;
    }

    const getGorunum = (r) =>
      cleanG(r.Gorunum && r.Gorunum.trim() ? r.Gorunum : "");

    // ============================================
    // GRUPLAR (buildStokOzetFromRaw içindeki BİREBİR aynı)
    // ============================================
    const GRUPLAR = {
      KIMYASAL: [
        "KİMYASAL YÜKSEK (C)",
        "KİMYASAL YÜKSEK ( C )",
        "KİMYASAL YÜKSEK ( C )-",
        "KİMYASAL YÜKSEK ( Cr )",
        "KİMYASAL YÜKSEK ( Mn )",
        "KİMYASAL YÜKSEK ( Si )",
        "KİMYASAL ÖZ. YÜKSEK",
        "KİMYASAL ÖZ. YÜKSEK - (U2)",
        "KİMYASAL ÖZ. YÜKSEK-",
        "-KİMYASAL YÜKSEK ( C )",
        "KİMYASAL ÖZ. YÜKSEK - (U2)-",
        "KİMYASAL YÜKSEK (Si)",
        "-KİMYASAL YÜKSEK (Si)",
      ],
      MEKANIK: [
        "MEKANİK TEST YÜKSEK",
        "SERT MALZEME (KİMYASAL VE MEKANİK YÜKSEK)",
        "SERT MALZEME (MEKANİK VE KİMYASAL YÜKSEK) - (U1)",
      ],
      PASLI: [
        "BEYAZ PAS",
        "1. DERECE (PAS)",
        "1. DERECE (PAS) - (Y7)",
        "2. DERECE (BÖLGESEL PAS)",
        "2. DERECE (BÖLGESEL PAS) - (Y45)",
        "3. DERECE (NOKTA NOKTA PAS)",
        "3. DERECE (NOKTA NOKTA PAS) - (Y46)",
        "3. DERECE (NOKTA NOKTA PAS)-",
        "-3. DERECE (NOKTA NOKTA PAS)",
        "TAV YANIĞI (MENEVİŞ RENK)",
        "SİYAH LEKE",
        "SİYAH LEKE-",
        "SİYAH LEKE - (Y10)",
        "ÇİZİK",
        "KIRIK",
      ],
      MAKINA: [
        "TAV YANIĞI (MENEVİŞ RENK) - (Y9)",
        "BOY TOLERANS DIŞI (UZUN) - (B2)",
        "KIRIK - (Y11)",
        "EBAT TOLERANS DIŞI",
        "ET KALINLIĞI TOLERANS DIŞI",
        "BOY TOLERANS DIŞI (UZUN-KISA)",
        "BOY TOLERANS DIŞI (UZUN)",
        "BOY TOLERANS DIŞI (KISA)",
        "BOY TOLERANS DIŞI (KISA) - (B3)",
        "EĞRİLİK TOLERANS DIŞI",
        "EĞRİLİK TOLERANS DIŞI - (E)",
        "RADYÜS TOLERANS DIŞI",
        "AĞIZ DİKLİĞİNDEN SAPMA",
        "İÇ-DIŞ BÜKEYLİK TOLERANS DIŞI",
        "DIŞ YÜZEY GR - İÇ YÜZEY SOĞUK -",
        "BURULMA PROBLEMİ",
        "OVALİTE PROBLEMİ",
        "KAYNAKTA BİNDİRME",
        "KAYNAK YÜZEYİ BOZUK",
        "KALIP İZİ - (Y1)",
        "BOY TOLERANS DIŞI (UZUN-KISA) - (B1)",
        "EZME TESTİNDE AÇMA - (A2)",
        "POTLU",
        "POTLU - (A6)",
        "ŞİŞİRME TESTİNDE AÇMA",
        "ŞİŞİRME TESTİNDE AÇMA - (A1)",
        "EZME TESTİNDE AÇMA",
        "BÜKME TESTİNDE AÇMA",
        "KALIP İZİ",
        "MENGENE İZİ",
        "MENGENE İZİ - (Y3)",
        "YARIMAMÜL KAYNAKLI ÇİZİK",
        "YARIMAMÜL KAYNAKLI ÇİZİK - (Y2)",
        "ÇİZİK",
        "OLUK VE EZİK",
        "TESTERE DEFORMASYON",
        "TESTERE DEFORMASYON - (T2)",
        "DEFORMASYON (ÇARPMA-TAŞIMA)",
        "TESTERE ÇAPAK",
        "PÜSKÜRTME ZAYIF",
        "PÜSKÜRTMESİZ (GR TEL)",
        "PÜSKÜRTMELİ (GR TEL)",
        "PÜSKÜRTME KALKMASI",
        "EZME-BÜKMEDE MALZEMEDEN YIRTILMA",
        "YETERSİZ SÜZDÜRME",
        "YÜKLEME PROBLEMLERİ",
        "KAYNAK CÜRUF (B/P İÇİNDE KAYNAK AKINTISI)",
        "KAYNAKTA EKSENEL KAYMA",
      ],
    };

    // ============================================
    // GRUPLAR_SET (birebir aynı)
    // ============================================
    const GRUPLAR_SET = {
      KIMYASAL: new Set(GRUPLAR.KIMYASAL.map(cleanG)),
      MEKANIK: new Set(GRUPLAR.MEKANIK.map(cleanG)),
      PASLI: new Set(GRUPLAR.PASLI.map(cleanG)),
      MAKINA: new Set(GRUPLAR.MAKINA.map(cleanG)),
    };

    // ============================================
    // kategoriBul (birebir aynı)
    // ============================================
    const kategoriBul = (gor) => {
      const g = cleanG(gor);
      if (GRUPLAR_SET.KIMYASAL.has(g)) return "KIMYASAL";
      if (GRUPLAR_SET.MEKANIK.has(g)) return "MEKANIK";
      if (GRUPLAR_SET.PASLI.has(g)) return "PASLI";
      if (GRUPLAR_SET.MAKINA.has(g)) return "MAKINA";
      return "TEMIZ";
    };

    // ============================================
    // 👇 buildStokOzetFromRaw ile AYNI GRUPLAMA
    // ============================================
    const kimyasalGrup = data.filter(
      (r) => kategoriBul(getGorunum(r)) === "KIMYASAL"
    );
    const mekanikGrup = data.filter(
      (r) => kategoriBul(getGorunum(r)) === "MEKANIK"
    );
    const pasliGrup = data.filter(
      (r) => kategoriBul(getGorunum(r)) === "PASLI"
    );
    const makinaGrup = data.filter(
      (r) => kategoriBul(getGorunum(r)) === "MAKINA"
    );
    const digerGrup = data.filter(
      (r) => kategoriBul(getGorunum(r)) === "TEMIZ"
    );

    // ============================================
    // Excel yazma (Aynı)
    // ============================================
    const writeSection = (title, list) => {
      ws.addRow([]);
      const titleRow = ws.addRow([title]);
      const colorEndCol = 11;

      for (let col = 1; col <= colorEndCol; col++) {
        const cell = ws.getCell(titleRow.number, col);
        if (col === 1) cell.value = title;
        cell.font = { bold: true, color: { argb: COLORS.WHITE }, size: 12 };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: color },
        };
      }

      ws.mergeCells(titleRow.number, 1, titleRow.number, colorEndCol);
      if (!list.length) return;

      list.sort((a, b) => num(b["Kalınlık"]) - num(a["Kalınlık"]));
      list.forEach((r) => {
        const addedRow = ws.addRow(mapRowToHeaders_BP_Stok(r));

        // --- KARANTİNA DEPO GÖRSEL AYRIMI ---
        if (r["StokYeri"] === "KARANTİNA DEPO") {
          addedRow.eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFFFF00" }, // Sarı dolgu
            };
          });
        }
        // ------------------------------------
      });

      const total = list.reduce((s, r) => s + num(r.ToplamKg), 0);
      const tr = ws.addRow(["GRUP TOPLAM", "", "", "", "", total, "", "", ""]);
      tr.font = { bold: true };
      tr.eachCell((c) => {
        c.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: COLORS.TOTAL },
        };
      });
    };

    // ============================================
    // Sıralı yazma (Aynen kaldı)
    // ============================================
    writeSection("KİMYASAL ÖZELLİKLERİ UYGUN OLMAYANLAR", kimyasalGrup);
    writeSection("MEKANİK ÖZELLİKLERİ UYGUN OLMAYANLAR", mekanikGrup);
    writeSection("PASLI ÜRÜNLER", pasliGrup);
    writeSection(
      "MAKİNA VE DİĞER HATALARDAN KAYNAKLI PROBLEMLİ ÜRÜNLER",
      makinaGrup
    );
    writeSection("TEMİZ ÜRÜNLER", digerGrup);

    autosizeSmartBP(ws);
    setCellStyle(ws);
    setFullBorder(ws);
    applyDefaultSize(ws);
    setColumnWidthsByHeaders(ws, ["Tip"], 21);
    setColumnWidthsByHeaders(ws, ["Görünüm"], 41);
    setColumnWidthsByHeaders(ws, ["CARİ ÜNVAN"], 60);
    applyGlobalFont(ws);
  }

  const ORDER_MAIN = [
    ["CR RULO STOK", COLORS.CR, rCR, "RULO", "CR"],
    ["CR BAND STOK", COLORS.CR, bCR, "BAND", "CR"],
    ["GR RULO STOK", COLORS.GR, rGR, "RULO", "GR"],
    ["GR BAND STOK", COLORS.GR, bGR, "BAND", "GR"],
    ["FH BAND STOK", COLORS.FH, bFH, "BAND", "FH"],
    ["MAGNELIS RULO STOK", COLORS.MAG, rMAG, "RULO", "MAG"],
    ["MAGNELIS BAND STOK", COLORS.MAG, bMAG, "BAND", "MAG"],
    ["HR RULO STOK", COLORS.HR, rHR, "RULO", "HR"],
    ["HR BAND STOK", COLORS.HR, bHR, "BAND", "HR"],
    ["GALVANİL RULO STOK", COLORS.GANIL, rGAN, "RULO", "GANIL"],
    ["GALVANİL BAND STOK", COLORS.GANIL, bGAN, "BAND", "GANIL"],
    ["CR STOK BP", COLORS.CR, pCR_STOK, "BP_STOK"],
    ["CR OPSİYON BP", ARGB("#A9D08E"), pCR_OPS, "BP_OPS"],
    ["GR STOK BP", COLORS.GR, pGR_STOK, "BP_STOK"],
    ["GR OPSİYON BP", ARGB("#BFBFBF"), pGR_OPS, "BP_OPS"],
    ["HR STOK BP", COLORS.HR, pHR_STOK, "BP_STOK"],
    ["HR OPSİYON BP", ARGB("#FFE699"), pHR_OPS, "BP_OPS"],
  ];
  // ==========================================================
  // KALINLIK KIRILIMI ↔ GELECEK REZERV BAĞLANTISI
  // F (GELECEK OPSİYONLU) = ilgili GELECEK sheet'indeki REZERV (L) toplamı
  // eşleşme: cins (CR / GR / FULLHARD) + kalınlık
  // ==========================================================
  const kalinlikKey = (v) => String(Number(String(v ?? "").replace(",", ".")));
  const kalinlikKirilimiRefs = {
    ws: null,
    // KALINLIK KIRILIMI tablo satırları: { CR: { "0.6": 7 }, ... }
    rows: { CR: {}, GR: {}, FULLHARD: {} },
    // GELECEK sheet REZERV satırları: { "CR GELECEK": { "0.6": [15, 27] }, ... }
    rezerv: {},
    // GELECEK sheet satırları (termin dahil): { "CR GELECEK": [{ kal, row, termin }] }
    gelecekRows: {},
    anaGelecek: [], // ANA sheet GELECEK bölümü satırları (SATIŞ bağlantısı)
  };
  const GELECEK_TO_KIRILIM = {
    "CR GELECEK": "CR",
    "GR GELECEK": "GR",
    "FH GELECEK": "FULLHARD",
  };

  // ANA ↔ GELECEK eşleşme anahtarı: sözleşme + menşei + cins + tip
  function anaGelecekKey(sozlesme, mensei, cins, tip) {
    const n = (v) =>
      String(v ?? "").trim().toLocaleUpperCase("tr-TR").replace(/\s+/g, " ");
    return [n(sozlesme) || "KONTRAT YOK", n(mensei), n(cins), n(tip)].join("|");
  }

  // ANA sheet GELECEK bölümü:
  //   SATIŞ (F)  = ilgili GELECEK sheet satırlarının REZERV (L) toplamı (ton)
  //   MİKTAR (E) = toplam miktar - SATIŞ
  const linkAnaSatisToGelecek = () => {
    const ws = wb.getWorksheet("ANA");
    if (!ws) return;

    const rezervByKey = {};
    Object.entries(kalinlikKirilimiRefs.gelecekRows).forEach(([sheet, rows]) => {
      const cins = sheet.replace(/ GELECEK$/, "");
      rows.forEach((g) => {
        const key = anaGelecekKey(g.sozlesme, g.mensei, cins, g.tip);
        (rezervByKey[key] = rezervByKey[key] || []).push(`'${sheet}'!L${g.row}`);
      });
    });

    kalinlikKirilimiRefs.anaGelecek.forEach(({ row, toplam, key }) => {
      const refs = rezervByKey[key];
      if (!refs || !refs.length) return; // REZERV yoksa SATIŞ boş, MİKTAR = toplam

      const satis = ws.getCell(row, 6);
      satis.value = { formula: `(${refs.join("+")})/1000` };
      satis.numFmt = '#,##0.###;-#,##0.###;""';

      const miktar = ws.getCell(row, 5);
      miktar.value = { formula: `${Number(toplam) || 0}-F${row}` };
      miktar.numFmt = "#,##0.###";
    });
  };

  const linkRezervToKalinlikKirilimi = () => {
    const ws = kalinlikKirilimiRefs.ws;
    if (!ws) return;

    Object.entries(GELECEK_TO_KIRILIM).forEach(([gelecekSheet, tablo]) => {
      const tabloRows = kalinlikKirilimiRefs.rows[tablo] || {};
      const rezervRows = kalinlikKirilimiRefs.rezerv[gelecekSheet] || {};

      Object.entries(tabloRows).forEach(([kal, rowNum]) => {
        const refs = rezervRows[kal] || [];
        if (!refs.length) return; // GELECEK satırı yoksa 0 kalır

        ws.getCell(rowNum, 6).value = {
          formula: refs.map((r) => `'${gelecekSheet}'!L${r}`).join("+"),
        };
      });
    });
  };


  // ==========================================================
  // HAMMADDE-ÜRETİM ANALİZ SHEET'İ
  // STOK  → KALINLIK KIRILIMI (D = satılabilir, C = opsiyonlu)
  // AYLAR → GELECEK sheet'leri, TERMİN ayına göre:
  //         SATILABİLİR = GÖKTAŞ KALAN (K), OPSİYONLU = REZERV (L)
  // ÜRETİM ve KRİTİK STOK personel tarafından elle girilir.
  // ==========================================================
  const AY_ADLARI = HU_AY_ADLARI;

  const parseTerminMonth = (v) => {
    if (!v) return null;
    if (v instanceof Date && !isNaN(v)) return v.getFullYear() * 12 + v.getMonth();
    const s = String(v).trim();
    let m = s.match(/^(\d{1,2})[-./](\d{1,2})[-./](\d{4})/); // 29-10-2026
    if (m) return Number(m[3]) * 12 + (Number(m[2]) - 1);
    m = s.match(/^(\d{4})[-./](\d{1,2})[-./](\d{1,2})/); // 2026-10-29
    if (m) return Number(m[1]) * 12 + (Number(m[2]) - 1);
    const d = new Date(s);
    if (!isNaN(d)) return d.getFullYear() * 12 + d.getMonth();
    return null;
  };

  const HU_BLACK = "FF000000";
  const HU_BLOCKS = [
    { title: "CR", tur: "SOĞUK", kirilim: "CR", gelecek: "CR GELECEK", color: "FF0070C0", kritik: true },
    { title: "GR", tur: "GALVANİZ", kirilim: "GR", gelecek: "GR GELECEK", color: "FFBFBFBF", kritik: true },
    { title: "HR", tur: "SICAK", kirilim: null, gelecek: "HR GELECEK", color: "FFFFC000", kritik: false },
    { title: "FH", tur: "FULLHARD", kirilim: "FULLHARD", gelecek: "FH GELECEK", color: "FFFF0000", kritik: false },
    // BAND cinsleri: stok band verisinden (Tür Detay), GELECEK sheet'i yok
    { title: "CFF BAND", band: "SOGUK FULLHARD FIRIN", kirilim: null, gelecek: null, color: "FFF8CBAD", kritik: false },
    { title: "CRSF BAND", band: "SOGUK FULLHARD SKINPASS", kirilim: null, gelecek: null, color: "FFB4C6E7", kritik: false },
  ];

  // "SOĞUK FULLHARD SKİNPASS" → "SOGUK FULLHARD SKINPASS"
  const huNormDetay = (v) =>
    String(v || "")
      .toLocaleUpperCase("tr-TR")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  // Band stok analizi (kalınlık bazında satılabilir / opsiyonlu)
  const huBandAnaliz = (bandData = [], detay) => {
    const byKal = {};
    bandData.forEach((r) => {
      if (huNormDetay(r["Tür Detay"] || r["Tür"]) !== detay) return;
      const kalinlik = Number(String(r["Kalınlık"] ?? "").replace(",", "."));
      if (isNaN(kalinlik)) return;
      const kg = Number(r.ToplamKg) || 0;
      const t = (byKal[kalinlik] = byKal[kalinlik] || {
        kalinlik,
        stokSatilabilir: 0,
        stokOpsiyonlu: 0,
      });
      if (r["Cari Ünvanı"] === "--1. KALİTE ÜRETİM STOK--") t.stokSatilabilir += kg;
      else t.stokOpsiyonlu += kg;
    });
    return Object.values(byKal);
  };

  // Şablondaki hücre stilleri (HAMMADDE-ÜRETİM ANALİZ.xlsx ile birebir)
  // b: kenarlık → L/R/T/B + m(medium) / t(thin) / -(yok)
  const HU_STYLES = {
    title: { f: { size: 20, bold: true }, b: "LmRtTmBt", a: "cc" },
    t1: { b: "L-R-TmB-" }, t1End: { b: "L-RtTmB-" },
    t2: { b: "LmR-T-Bt" }, t2Mid: { b: "L-R-T-Bt" }, t2End: { b: "L-RtT-Bt" },
    plainC: { a: "cc" },
    sep: { fill: HU_BLACK, a: "cc" },
    sepTop: { fill: HU_BLACK, b: "L-R-TtBt", a: "cc" },
    stokHdr: { f: { size: 12, bold: true }, b: "LmRtTmBt", a: "cc" },
    stokHdrEnd: { b: "L-RtTmBt" },
    ayHdr: { f: { size: 14, bold: true }, b: "LmRtTmBt", a: "cc" },
    ayHdrMid: { b: "L-R-TmBt" },
    lblA: { f: { size: 10, bold: true }, b: "LmRtTtBt", a: "ccw" },
    lblAEnd: { b: "L-RtTtB-" },
    lblB: { f: { size: 10, bold: true }, b: "LtRtTtBt", a: "ccw" },
    lblC: { f: { size: 9, bold: true }, b: "LtRmTtBt", a: "ccw" },
    lowA: { b: "LmR-T-Bt" }, lowAEnd: { b: "L-RtT-Bt" },
    lowB: { b: "LtR-T-Bt" }, lowC: { b: "LtRmT-Bt" },
    topValA: { f: { bold: true }, b: "LmRtTtBt", a: "cc", nf: "#,##0" },
    topValB: { f: { bold: true }, b: "LtRtTtBt", a: "cc", nf: "#,##0" },
    topValC: { f: { size: 12, bold: true }, b: "LtRmTtBt", a: "cc", nf: "#,##0" },
    blkTitleMid: { b: "L-R-TmBm" }, blkTitleEnd: { b: "L-RmTmBm" },
    h1A: { f: { size: 12, bold: true }, b: "LmRmTmBt", a: "cc" },
    h2A: { f: { size: 12, bold: true }, b: "LmRmTtBt", a: "cc" },
    hazir: { f: { size: 12, bold: true }, b: "LmRtTtBt", a: "cc" },
    h2Mid: { b: "L-RtTtBt" },
    gelecekHdr: { f: { bold: true }, b: "LmRtTtBt", a: "cc" },
    uretimHdr: { f: { bold: true }, b: "LtRtTtBt", a: "cc" },
    devirHdr: { f: { bold: true }, fill: "FFF4B084", b: "LtRmTtBt", a: "ccw" },
    devirLow: { fill: "FFF4B084", b: "LtRmT-Bt", a: "ccw" },
    kalHdr: { f: { size: 10, bold: true }, b: "LmRmTtBt", a: "cc" },
    satHdr: { f: { size: 10, bold: true }, fill: "FF92D050", b: "LmRtTtBt", a: "cc" },
    opsHdrEnd: { f: { size: 10, bold: true }, fill: "FFFFFF00", b: "LtRmTtBt", a: "cc" },
    opsHdr: { f: { size: 10, bold: true }, fill: "FFFFFF00", b: "LtRtTtBt", a: "cc" },
    sipHdr: { f: { size: 10, bold: true }, fill: "FFFFC000", b: "LtRtTtBt", a: "cc" },
    stkHdr: { f: { size: 10, bold: true }, fill: "FF00B0F0", b: "LtRtTtBt", a: "cc" },
    kritikHdr: { f: { size: 10, bold: true }, b: "LtRtTtBt", a: "ccw" },
    kal: { f: { name: "Arial", bold: true }, b: "LmRmTtBt", a: "ccw" },
    dA: { b: "LmRtTtBt", a: "cc", nf: "#,##0" },
    dB: { b: "LtRtTtBt", a: "cc", nf: "#,##0" },
    gA: { b: "LmRtTtBt", a: "cc", nf: '#,##0;-#,##0;""' },
    gB: { b: "LtRtTtBt", a: "cc", nf: '#,##0;-#,##0;""' },
    dC: { b: "LtRmTtBt", a: "cc", nf: "#,##0" },
    dD: { b: "LtR-TtBt", a: "cc", nf: "#,##0" },
    tKal: { b: "LmRmTtBm", a: "cc" },
    tA: { f: { bold: true }, b: "LmRtTtBm", a: "cc", nf: "#,##0" },
    tB: { f: { bold: true }, b: "LtRtTtBm", a: "cc", nf: "#,##0" },
    tC: { f: { bold: true }, b: "LtRmTtBm", a: "cc", nf: "#,##0" },
    tKritik: { f: { bold: true }, b: "LtRtTtBt", a: "cc", nf: "#,##0" },
  };

  const huApply = (ws, row, col, key, value) => {
    const s = HU_STYLES[key] || {};
    const cell = ws.getCell(row, col);
    const f = s.f || {};
    const border = {};
    const SIDES = { L: "left", R: "right", T: "top", B: "bottom" };
    (s.b || "").replace(/([LRTB])([mt-])/g, (_, side, w) => {
      if (w !== "-") {
        border[SIDES[side]] = {
          style: w === "m" ? "medium" : "thin",
          color: { argb: HU_BLACK },
        };
      }
      return "";
    });
    // Birleşik hücrelerde ExcelJS stil nesnesini paylaşır;
    // her hücreye YENİ bir stil nesnesi veriyoruz ki ana hücre bozulmasın.
    cell.style = {
      font: {
        name: f.name || "Calibri",
        size: f.size || 11,
        bold: !!f.bold,
        color: { argb: HU_BLACK },
      },
      fill: s.fill
        ? { type: "pattern", pattern: "solid", fgColor: { argb: s.fill } }
        : { type: "pattern", pattern: "none" },
      border,
      alignment: s.a
        ? { horizontal: "center", vertical: "middle", wrapText: s.a === "ccw" }
        : {},
      numFmt: s.nf || "General",
    };
    if (value !== undefined) cell.value = value;
    return cell;
  };

  function fillHammaddeUretimSheet(ws, analiz, ayAraligi = {}) {
    if (!ws) return;

    // ---------- AYLAR ----------
    // Kullanıcının seçtiği aralık (HU_AY_ARALIK sınırları içinde).
    // Geçmiş aylar raporda gösterilmez. Termini geçmiş ama gelmemiş
    // hammadde içinde bulunulan aya eklenir
    // (ör. termin 1.1.2026, biz ŞUBAT'tayız → OCAK yok, ŞUBAT'a eklenir;
    //  EKİM'de gelmesi gereken veri gelmediyse KASIM'a eklenir).
    const ayLabel = (i) => `${AY_ADLARI[i % 12]} ${Math.floor(i / 12)}`;
    const minIdx = ayKeyToIdx(HU_AY_ARALIK.min);
    const maxIdx = ayKeyToIdx(HU_AY_ARALIK.max);
    const currentIdx = buAyIdx();
    const clampIdx = (i) => Math.max(minIdx, Math.min(maxIdx, i));

    let selStart = ayKeyToIdx(ayAraligi.baslangic);
    let selEnd = ayKeyToIdx(ayAraligi.bitis);
    if (selStart === null) selStart = currentIdx;
    if (selEnd === null) selEnd = maxIdx;
    selStart = clampIdx(selStart);
    selEnd = clampIdx(selEnd);
    if (selStart > selEnd) [selStart, selEnd] = [selEnd, selStart];

    const startIdx = Math.max(selStart, currentIdx);
    const endIdx = Math.max(selEnd, startIdx);

    const gelecekByBlock = {};
    HU_BLOCKS.forEach((b) => {
      if (!b.gelecek) return; // band blokları: GELECEK sheet'i yok
      gelecekByBlock[b.gelecek] = (
        kalinlikKirilimiRefs.gelecekRows[b.gelecek] || []
      ).map((g) => {
        let idx = parseTerminMonth(g.termin);
        // termin yok / geçmiş ve gelmemiş → içinde bulunulan ay
        if (idx === null || idx < currentIdx) idx = currentIdx;
        // raporun ilk ayından önce → ilk ay, son ayından sonra → son ay
        idx = Math.max(startIdx, Math.min(endIdx, idx));
        return { ...g, pos: idx - startIdx };
      });
    });

    const months = [];
    for (let i = startIdx; i <= endIdx; i++) {
      months.push({ idx: i, label: ayLabel(i) });
    }

    const M = months.length;
    const mCol = (m) => 5 + m * 5; // her ay 5 kolon: SAT, OPS, SİPARİŞ, STOK, DEVİR
    const SEP = 5 + M * 5; // sağdaki siyah ayraç
    const KR1 = SEP + 1;
    const KR2 = SEP + 2;
    const L = (c) => ws.getColumn(c).letter;

    // ---------- GENEL GÖRÜNÜM ----------
    ws.views = [
      { state: "frozen", xSplit: 1, ySplit: 0, topLeftCell: "B1", zoomScale: 70, zoomScaleNormal: 70 },
    ];
    ws.getColumn(1).width = 17.33;
    ws.getColumn(2).width = 10.33;
    ws.getColumn(3).width = 10.33;
    ws.getColumn(4).width = 1.11;
    for (let c = 5; c < SEP; c++) ws.getColumn(c).width = 10.33;
    ws.getColumn(SEP).width = 1.11;
    ws.getColumn(KR1).width = 11.33;
    ws.getColumn(KR2).width = 11.33;

    // ---------- ANA BAŞLIK (1-2) ----------
    ws.mergeCells(1, 1, 2, SEP);
    for (let c = 1; c <= SEP; c++) {
      huApply(ws, 1, c, c === 1 ? "title" : c === SEP ? "t1End" : "t1");
      huApply(ws, 2, c, c === 1 ? "t2" : c === SEP ? "t2End" : "t2Mid");
    }
    huApply(ws, 1, 1, "title", "HAMMADDE-ÜRETİM ANALİZ TABLOSU");

    // ---------- ÜST ÖZET (4-8) ----------
    ws.mergeCells(4, 2, 4, 3);
    ws.mergeCells(5, 2, 6, 3);
    ws.mergeCells(7, 2, 8, 3);
    months.forEach((_, m) => {
      const c = mCol(m);
      ws.mergeCells(4, c, 4, c + 4);
      ws.mergeCells(5, c, 6, c + 1);
      ws.mergeCells(5, c + 2, 6, c + 3);
      ws.mergeCells(5, c + 4, 6, c + 4);
      ws.mergeCells(7, c, 8, c + 1);
      ws.mergeCells(7, c + 2, 8, c + 3);
      ws.mergeCells(7, c + 4, 8, c + 4);
    });

    huApply(ws, 4, 1, "plainC");
    huApply(ws, 4, 2, "stokHdr", "STOK");
    huApply(ws, 4, 3, "stokHdrEnd");
    huApply(ws, 5, 2, "lblA", "Stok Hammadde Toplam Miktar(ton)");
    huApply(ws, 5, 3, "lblAEnd");
    [6, 8].forEach((r) => {
      huApply(ws, r, 2, "lowA");
      huApply(ws, r, 3, "lowAEnd");
    });
    huApply(ws, 7, 2, "topValA");
    huApply(ws, 7, 3, "lblAEnd");
    for (let r = 4; r <= 8; r++) {
      huApply(ws, r, 4, "sepTop");
      huApply(ws, r, SEP, "sep");
    }

    months.forEach((mo, m) => {
      const c = mCol(m);
      huApply(ws, 4, c, "ayHdr", mo.label);
      huApply(ws, 4, c + 1, "ayHdrMid");
      huApply(ws, 4, c + 2, "ayHdrMid");
      huApply(ws, 4, c + 3, "ayHdrMid");
      huApply(ws, 4, c + 4, "stokHdrEnd");

      huApply(ws, 5, c, "lblA", "Gelecek Hammadde Toplam Miktar(ton)");
      huApply(ws, 5, c + 1, "lblAEnd");
      huApply(ws, 5, c + 2, "lblB", "Üretim Toplam Miktar(ton)");
      huApply(ws, 5, c + 3, "lblAEnd");
      huApply(ws, 5, c + 4, "lblC", "Toplam Devir Miktar");

      [6, 8].forEach((r) => {
        huApply(ws, r, c, "lowA");
        huApply(ws, r, c + 1, "lowAEnd");
        huApply(ws, r, c + 2, "lowB");
        huApply(ws, r, c + 3, "lowAEnd");
        huApply(ws, r, c + 4, "lowC");
      });

      huApply(ws, 7, c, "topValA");
      huApply(ws, 7, c + 1, "lblAEnd");
      huApply(ws, 7, c + 2, "topValB");
      huApply(ws, 7, c + 3, "lblAEnd");
      huApply(ws, 7, c + 4, "topValC");
    });

    // ---------- CİNS BLOKLARI ----------
    let r0 = 13;
    const totalRows = [];

    HU_BLOCKS.forEach((blk) => {
      const kirilimRows = blk.kirilim
        ? kalinlikKirilimiRefs.rows[blk.kirilim] || {}
        : {};
      const analizRows = blk.band
        ? huBandAnaliz(band, blk.band)
        : (analiz && analiz[blk.tur]) || [];
      const gelecekList = (blk.gelecek && gelecekByBlock[blk.gelecek]) || [];

      // Kalınlık listesi: KALINLIK KIRILIMI sırası + sadece GELECEK'te olanlar
      const kalMap = new Map();
      analizRows.forEach((a) => kalMap.set(kalinlikKey(a.kalinlik), a));
      gelecekList.forEach((g) => {
        if (!kalMap.has(g.kal)) kalMap.set(g.kal, { kalinlik: Number(g.kal) });
      });
      const kalList = [...kalMap.entries()]
        .filter(([k]) => k !== "NaN")
        .sort((a, b) => Number(b[0]) - Number(a[0]));

      const h1 = r0 + 1;
      const h2 = r0 + 2;
      const h3 = r0 + 3;
      const dataStart = h3 + 1;
      const dataEnd = dataStart + kalList.length - 1;
      const tRow = dataEnd + 1;

      // --- birleştirmeler ---
      ws.mergeCells(r0, 1, r0, SEP);
      ws.mergeCells(h1, 2, h1, 3);
      ws.mergeCells(h2, 2, h2, 3);
      ws.mergeCells(h1, 4, tRow, 4);
      ws.mergeCells(h1, SEP, tRow, SEP);
      months.forEach((_, m) => {
        const c = mCol(m);
        ws.mergeCells(h1, c, h1, c + 4);
        ws.mergeCells(h2, c, h2, c + 1);
        ws.mergeCells(h2, c + 2, h2, c + 3);
        ws.mergeCells(h2, c + 4, h3, c + 4);
      });
      if (blk.kritik) {
        ws.mergeCells(h1, KR1, h3, KR1);
        ws.mergeCells(h1, KR2, h3, KR2);
      }

      // --- blok başlığı ---
      for (let c = 1; c <= SEP; c++) {
        huApply(ws, r0, c, c === SEP ? "blkTitleEnd" : "blkTitleMid");
      }
      const tc = ws.getCell(r0, 1);
      tc.value = blk.title;
      tc.style = {
        font: { name: "Arial", size: 20, bold: true, color: { argb: HU_BLACK } },
        fill: { type: "pattern", pattern: "solid", fgColor: { argb: blk.color } },
        alignment: { horizontal: "center", vertical: "middle", wrapText: true },
        border: {
          top: { style: "medium", color: { argb: HU_BLACK } },
          left: { style: "medium", color: { argb: HU_BLACK } },
          bottom: { style: "medium", color: { argb: HU_BLACK } },
          right: { style: "medium", color: { argb: HU_BLACK } },
        },
        numFmt: "General",
      };

      // --- başlık satırları ---
      huApply(ws, h1, 1, "h1A");
      huApply(ws, h1, 2, "stokHdr", "STOK");
      huApply(ws, h1, 3, "stokHdrEnd");
      huApply(ws, h2, 1, "h2A");
      huApply(ws, h2, 2, "hazir", "HAZIR");
      huApply(ws, h2, 3, "h2Mid");
      huApply(ws, h3, 1, "kalHdr", "KALINLIK");
      huApply(ws, h3, 2, "satHdr", "SATILABİLİR");
      huApply(ws, h3, 3, "opsHdrEnd", "OPSİYONLU");

      months.forEach((mo, m) => {
        const c = mCol(m);
        huApply(ws, h1, c, "ayHdr", mo.label);
        huApply(ws, h1, c + 1, "ayHdrMid");
        huApply(ws, h1, c + 2, "ayHdrMid");
        huApply(ws, h1, c + 3, "ayHdrMid");
        huApply(ws, h1, c + 4, "stokHdrEnd");

        huApply(ws, h2, c, "gelecekHdr", "GELECEK HAMMADDE");
        huApply(ws, h2, c + 1, "h2Mid");
        huApply(ws, h2, c + 2, "uretimHdr", "ÜRETİM");
        huApply(ws, h2, c + 3, "h2Mid");
        huApply(ws, h2, c + 4, "devirHdr", "DEVİR MİKTAR");

        huApply(ws, h3, c, "satHdr", "SATILABİLİR");
        huApply(ws, h3, c + 1, "opsHdr", "OPSİYONLU");
        huApply(ws, h3, c + 2, "sipHdr", "SİPARİŞ");
        huApply(ws, h3, c + 3, "stkHdr", "STOK");
        huApply(ws, h3, c + 4, "devirLow");
      });

      if (blk.kritik) {
        [h1, h2, h3].forEach((r) => {
          huApply(ws, r, KR1, "kritikHdr");
          huApply(ws, r, KR2, "kritikHdr");
        });
        ws.getCell(h1, KR1).value = "İÇ PİYASA KRİTİK STOK SEVİYESİ";
        ws.getCell(h1, KR2).value = "İHRACAT KRİTİK STOK SEVİYESİ";
      }

      // --- veri satırları ---
      kalList.forEach(([kal, a], i) => {
        const row = dataStart + i;

        huApply(ws, row, 1, "kal", Number(kal));

        // STOK HAZIR
        const kRow = kirilimRows[kal];
        if (blk.kirilim && kRow) {
          huApply(ws, row, 2, "dA", { formula: `'KALINLIK KIRILIMI'!D${kRow}` });
          huApply(ws, row, 3, "dC", { formula: `'KALINLIK KIRILIMI'!C${kRow}` });
        } else {
          huApply(ws, row, 2, "dA", a.stokSatilabilir || 0);
          huApply(ws, row, 3, "dC", a.stokOpsiyonlu || 0);
        }

        // AYLAR
        months.forEach((_, m) => {
          const c = mCol(m);
          const refs = gelecekList.filter(
            (g) => g.kal === kal && g.pos === m
          );

          huApply(ws, row, c, "gA");
          huApply(ws, row, c + 1, "gB");
          huApply(ws, row, c + 2, "dB");
          huApply(ws, row, c + 3, "dB");
          huApply(ws, row, c + 4, "dD");

          if (refs.length) {
            ws.getCell(row, c).value = {
              formula: refs.map((g) => `'${blk.gelecek}'!K${g.row}`).join("+"),
            };
            ws.getCell(row, c + 1).value = {
              formula: refs.map((g) => `'${blk.gelecek}'!L${g.row}`).join("+"),
            };
          }

          // DEVİR = (önceki devir / hazır stok + gelecek) - (sipariş + stok)
          const prev =
            m === 0
              ? `B${row}+C${row}`
              : `${L(mCol(m - 1) + 4)}${row}`;
          ws.getCell(row, c + 4).value = {
            formula: `(${prev}+${L(c)}${row}+${L(c + 1)}${row})-(${L(c + 2)}${row}+${L(c + 3)}${row})`,
          };
        });

        if (blk.kritik) {
          huApply(ws, row, KR1, "dB");
          huApply(ws, row, KR2, "dB");
        }
        ws.getRow(row).height = 14.4;
      });

      // --- toplam satırı ---
      const sumCell = (c) =>
        kalList.length
          ? { formula: `SUM(${L(c)}${dataStart}:${L(c)}${dataEnd})` }
          : 0;
      huApply(ws, tRow, 1, "tKal");
      huApply(ws, tRow, 2, "tA", sumCell(2));
      huApply(ws, tRow, 3, "tC", sumCell(3));
      months.forEach((_, m) => {
        const c = mCol(m);
        huApply(ws, tRow, c, "tA", sumCell(c));
        for (let k = 1; k <= 4; k++) huApply(ws, tRow, c + k, "tB", sumCell(c + k));
      });
      if (blk.kritik) {
        huApply(ws, tRow, KR1, "tKritik", sumCell(KR1));
        huApply(ws, tRow, KR2, "tKritik", sumCell(KR2));
      }

      // --- siyah ayraç kolonları ---
      for (let r = h1; r <= tRow; r++) {
        huApply(ws, r, 4, "sep");
        huApply(ws, r, SEP, "sep");
      }

      // --- satır yükseklikleri ---
      ws.getRow(r0).height = 30;
      ws.getRow(h1).height = 25.05;
      ws.getRow(h2).height = 25.05;
      ws.getRow(h3).height = 13.8;
      ws.getRow(tRow).height = 14.4;

      totalRows.push(tRow);
      r0 = tRow + 3; // bloklar arası 2 boş satır
    });

    // ---------- ÜST ÖZET FORMÜLLERİ (ton) ----------
    const sumTotals = (cols) =>
      totalRows.length
        ? { formula: `(${totalRows.flatMap((t) => cols.map((c) => `${L(c)}${t}`)).join("+")})/1000` }
        : 0;
    ws.getCell(7, 2).value = sumTotals([2, 3]);
    months.forEach((_, m) => {
      const c = mCol(m);
      ws.getCell(7, c).value = sumTotals([c, c + 1]);
      ws.getCell(7, c + 2).value = sumTotals([c + 2, c + 3]);
      ws.getCell(7, c + 4).value = sumTotals([c + 4]);
    });

    // ---------- ÜST SATIR YÜKSEKLİKLERİ ----------
    ws.getRow(2).height = 15;
    ws.getRow(3).height = 15;
    ws.getRow(4).height = 25.05;
    ws.getRow(5).height = 14.4;
    ws.getRow(6).height = 15.6;
    ws.getRow(7).height = 14.4;
    ws.getRow(8).height = 15;
  }

  const hammaddeAnalizLocal = buildHammaddeAnaliz(hammadde);
  const detay = buildGelecekDetay(hammadde);
  const satilabilirData = buildSatilabilirKgAnaliz(rulo, band, profil);
  const analizCrGrRuloData = analizCrGrRulo(rulo, hammadde);

  createTekSheet(hammaddeAnalizLocal, satilabilirData);
  createCrGrSheet(analizCrGrRuloData);
  const hammaddeUretimWs = wb.addWorksheet("HAMMADDE-ÜRETİM ANALİZ");

  ORDER_MAIN.forEach(([title, color, rows, mode, key]) => {
    if (title === "CR RULO STOK") {
      const stokOzetLocal = buildStokOzetFromRaw(rulo, band, profil);
      createStokOzetSheet(stokOzetLocal);
    }
    if (mode === "BP_STOK") return createBPStokGrouped(title, color, rows);
    if (mode === "BP_OPS") return createBPOps(title, color, rows);
    if (title === "FH BAND STOK") createFHRuloSheets();
    createRB(title, color, rows, mode, key);
  });
  createGelecekSheets(detay);
  linkRezervToKalinlikKirilimi();
  linkAnaSatisToGelecek();
  fillHammaddeUretimSheet(
    hammaddeUretimWs,
    analizCrGrRuloData,
    options.hammaddeUretimAy || {}
  );

  const createGroupedSheets = () => {
    const normalizeSheetName = (value = "") =>
      value
        .toString()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim();

    const IGNORE_SHEETS = [
      "RULO FULLHARD",
      "RULO SOĞUK",
      "RULO GALVANİZ",
      "RULO MAGNELİS",
      "RULO SICAK",
      "BAND SOĞUK",
      "BAND GALVANİZ",
      "BAND SICAK",
      "BAND FULLHARD",
      "BAND MAGNELİS",
      "BAND GALVANİL",
      "BORU-PRF SOĞUK",
      "BORU-PRF SICAK",
      "BORU-PRF GALVANİZ",
    ];
    const CUSTOM_STYLE_SHEETS = [
      "RULO SOĞUK HADDE",
      "RULO SOĞUK ASİTLİ HADDE",
      "RULO ASİTLİ",
      "RULO SOĞUK ASİTLİ FIRIN",
      "RULO SOĞUK FULLHARD HADDE",
      "RULO SOĞUK FULLHARD FIRIN",
      "RULO SOĞUK FULLHARD SKİNPASS",
      "RULO SİYAH SKİNPASS",
      "RULO GALVANİZ HADDE",
      "BAND SİYAH HADDE",
      "BAND SOĞUK FULLHARD FIRIN",
      "BAND SOĞUK SKİNPASS",
      "BAND SOĞUK FULLHARD SKİNPASS",
      "BAND SOĞUK FULLHARD HADDE",
      "BAND GALVANİZ HADDE",
      "BAND SOĞUK ASİTLİ SKİNPASS",
      "BAND SOĞUK FIRIN",
      "BAND SİYAH SKİNPASS",
      "BAND SOĞUK HADDE",
    ];
    const CUSTOM_STYLE_SHEET_SET = new Set(
      CUSTOM_STYLE_SHEETS.map(normalizeSheetName)
    );
    const CUSTOM_WIDTH_SHEETS = new Set(
      [
        "RULO SOĞUK FULLHARD FIRIN",
        "RULO SOĞUK FULLHARD SKINPASS",
        "BAND SOĞUK FULLHARD FIRIN",
        "BAND SOĞUK FULLHARD SKINPASS",
        "BAND GALVANİZ HADDE",
        "BAND SOĞUK SKINPASS",
      ].map(normalizeSheetName)
    );
    const CANONICAL_SHEET_NAMES = {
      "RULO ASITLI": "RULO ASİTLİ",
      "RULO SOGUK ASITLI FIRIN": "RULO SOĞUK ASİTLİ FIRIN",
    };

    const datasets = [
      { name: "RULO", data: rulo },
      { name: "BAND", data: band },
      { name: "BORU-PRF", data: profil },
    ];

    datasets.forEach(({ name, data }) => {
      if (!Array.isArray(data) || !data.length) return;

      const grouped = {};
      data.forEach((r) => {
        const detay =
          (r["Tür Detay"] || r["Tür"] || "").trim().toUpperCase() || "GENEL";
        const key = `${name} ${detay}`;
        // GENEL sheet istemiyorsan ENGELLE
        if (detay === "GENEL") return;

        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(r);
      });

      Object.entries(grouped).forEach(([key, rows]) => {
        rows = groupRB(rows);
        const normalizedKey = normalizeSheetName(key);

        if (IGNORE_SHEETS.includes(key.trim().toUpperCase())) return;

        let wsName = (CANONICAL_SHEET_NAMES[normalizedKey] || key).substring(
          0,
          28
        );
        while (wb.getWorksheet(wsName)) {
          wsName = wsName + " (GRUP)";
          if (wsName.length > 31) wsName = wsName.slice(0, 31);
        }

        const ws = wb.addWorksheet(wsName);

        //  Eğer özel listedeyse başlıkları sabitle
        if (CUSTOM_STYLE_SHEET_SET.has(normalizedKey)) {
          const headers = [
            "Tip",
            "Tür Detay",
            "Kalınlık (mm)",
            "Genişlik(mm)",
            "Kalite",
            "Adet",
            "Kaplama",
            "Miktar",
            "Yaşlanma",
            "CARİ ÜNVAN",
          ];
          ws.addRow(headers);

          //  Verileri ekle
          rows.sort((a, b) => num(b["Kalınlık"]) - num(a["Kalınlık"]));
          rows.forEach((r) => {
            const tip = key.includes("RULO")
              ? "RULO"
              : key.includes("BAND")
                ? "BAND"
                : key.includes("BORU")
                  ? "BORU-PRF"
                  : "";
            const mapped = [
              tip,
              r["Tür Detay"] ?? r["Tür"] ?? "",
              r["Kalınlık"] ?? "",
              r["Genişlik"] ?? "",
              r["Kalite"] ?? "",
              r["Adet"] ?? "",
              r["Kaplama"] ?? "",
              r["ToplamKg"] ?? r["Miktar"] ?? "",
              r["Yaslanma"] ?? "",
              r["Cari Ünvanı"] ?? "",
            ];
            const addedRow = ws.addRow(mapped);

            // --- KARANTİNA DEPO GÖRSEL AYRIMI ---
            if (r["StokYeri"] === "KARANTİNA DEPO") {
              addedRow.eachCell((cell) => {
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "FFFFFF00" }, // Sarı dolgu
                };
              });
            }
            // ------------------------------------
          });

          //  Genel toplam satırı
          const total = rows.reduce((s, r) => s + num(r.ToplamKg), 0);
          const totalRow = ws.addRow([
            "GENEL TOPLAM",
            "",
            "",
            "",
            "",
            "",
            "",
            total,
            "",
          ]);
          totalRow.font = { bold: true };
          totalRow.eachCell((c) => {
            c.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: COLORS.TOTAL },
            };
          });

          //  Kenarlık + ortalama
          setCellStyle(ws);
          applyHeaderThick(ws, 1, 10);
          applyDataSideBorders(ws, 2, ws.lastRow.number, 10);
          autosize(ws);
          applyDefaultSize(ws);
          setColumnWidthsByHeaders(ws, ["Tür Detay"], 30);
          setColumnWidthsByHeaders(ws, ["CARİ ÜNVAN"], 100);
          if (CUSTOM_WIDTH_SHEETS.has(normalizedKey)) {
            setColumnWidthsByHeaders(ws, ["Tip"], 19);
            setColumnWidthsByHeaders(ws, ["Tür Detay"], 40);
          }
          applyGlobalFont(ws);

          return; //  Bu sayfa tamamlandı, aşağıya geçmeden bitir
        }

        // Normal sayfalar için default işlem
        if (!rows.length) {
          ws.addRow([""]);
          return;
        }
        const headers = Object.keys(rows[0]);
        ws.addRow(headers);
        rows.forEach((r) => {
          // Her header için değer al

          const addedRow = ws.addRow(headers.map((h) => r[h]));

          // --- KARANTİNA DEPO GÖRSEL AYRIMI ---
          if (r["StokYeri"] === "KARANTİNA DEPO") {
            addedRow.eachCell((cell) => {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" }, // Sarı dolgu
              };
            });
          }
          // ------------------------------------

          setCellStyle(ws);
          applyHeaderThick(ws, 1, headers.length);
          applyDataSideBorders(ws, 2, ws.lastRow.number, headers.length);
          autosize(ws);
          applyDefaultSize(ws);
          applyGlobalFont(ws);
        });
        setColumnWidthsByHeaders(ws, ["Tür Detay"], 30);
        setColumnWidthsByHeaders(ws, ["Cari Ünvanı", "CARİ ÜNVAN"], 100);
      });
    });
  };

  function buildStokOzetFromRaw(rulo = [], band = [], profil = []) {
    rulo = JSON.parse(JSON.stringify(rulo));
    band = JSON.parse(JSON.stringify(band));
    profil = JSON.parse(JSON.stringify(profil));

    const normalizeText = (val = "") =>
      val
        .toString()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[().,-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const cleanG = (v = "") =>
      v
        .toString()
        .normalize("NFC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\u00A0/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const matchTur = (turRaw, hedef) => {
      const t = normalizeText(turRaw);
      const h = normalizeText(hedef);

      return t === h; // yalnızca tamamen FULLHARD olanlara eşleşsin
    };
    const num = (v) => parseFloat(String(v).replace(",", ".")) || 0;

    const rawUnusablePhrases = [
      "B/P İÇİN UYGUN DEĞİL",
      "KALINLIK DEĞİŞİMİ-DİLME AYRILACAK",
      "BOYKESİM İÇİN UYGUN",
      "TAV YANIĞI (MENEVİŞ RENK)",
      "KALINLIK FARKI VAR",
      "NİKEL KAPLAMA PARLAK YÜZEY ONAY ALINMADAN DİLİNMESİN",
      "BOHCA",
      "EK VAR",
      "BOYALI",
      "BOHÇA",
      "BOHÇA-BOYKESİM İÇİN UYGUN",
      "BOY KESİM İÇİN UYGUN",
      "İÇ-DIŞ SARIM KAL.FARKI",
    ];

    const isUnusable = (g3 = "") =>
      rawUnusablePhrases.some((p) => g3.toUpperCase().includes(p));

    const isUsable = (g3) => !isUnusable(g3);

    const sumByCari = (arr, filterFn) => {
      const data = arr.filter(filterFn);
      const grouped = {};
      data.forEach((r) => {
        const cari = normalizeText(r["Cari Ünvanı"]);
        if (!cari) return;
        const kg = num(r.Kg || r.ToplamKg);
        grouped[cari] = (grouped[cari] || 0) + kg;
      });
      const entries = Object.entries(grouped).sort(([aCari], [bCari]) => {
        if (aCari.includes("KALITE URETIM")) return -1;
        if (bCari.includes("KALITE URETIM")) return 1;
        return grouped[bCari] - grouped[aCari];
      });
      const toplam = entries.reduce((a, [, kg]) => a + kg, 0);
      const cariler = entries.map(([cari, kg]) => ({ cari, kg }));
      return { toplam, cariler };
    };

    // ============================
    // 🟣 FULLHARD RULO ANALİZİ
    // ============================
    const fhData = rulo.filter((r) => matchTur(r["Tür"], "FULLHARD"));

    const FH_RULO = {
      MOR_ROTA: {
        ALT_KULLANILAMAZ: sumByCari(
          fhData,
          (r) => num(r.Kalınlık) <= 0.53 && isUnusable(r["Gorunum3"] || "")
        ),
        UST_KULLANILAMAZ: sumByCari(
          fhData,
          (r) => num(r.Kalınlık) >= 0.54 && isUnusable(r["Gorunum3"] || "")
        ),
      },

      NORMAL: {
        ALT_KULLANILABILIR: sumByCari(
          fhData,
          (r) => num(r.Kalınlık) <= 0.53 && isUsable(r["Gorunum3"] || "")
        ),
        UST_KULLANILABILIR: sumByCari(
          fhData,
          (r) => num(r.Kalınlık) >= 0.54 && isUsable(r["Gorunum3"] || "")
        ),
        YESIL_ROTA: sumByCari(
          fhData,
          (r) =>
            num(r.Kalınlık) >= 0.54 &&
            num(r.Kalınlık) <= 1.2 &&
            isUsable(r["Gorunum3"] || "")
        ),
        KIRMIZI_ROTA: sumByCari(
          fhData,
          (r) => num(r.Kalınlık) >= 1.21 && isUsable(r["Gorunum3"] || "")
        ),
      },
    };

    // ✔ 3 MOR blok
    const MOR_ALT = FH_RULO.MOR_ROTA.ALT_KULLANILAMAZ.toplam;
    const MOR_MAKINA = FH_RULO.NORMAL.ALT_KULLANILABILIR.toplam; // MAKİNA kaynaklı blok
    const MOR_UST = FH_RULO.MOR_ROTA.UST_KULLANILAMAZ.toplam;

    // ⭐ Gerçek MOR_TOPLAM (3 blok)
    const MOR_TOPLAM = MOR_ALT + MOR_MAKINA + MOR_UST;

    // ============================
    // 🟣 FH_RULO_ANALIZ
    // ============================
    const FH_RULO_ANALIZ = {
      YESIL_ROTA: FH_RULO.NORMAL.YESIL_ROTA.toplam,
      KIRMIZI_ROTA: FH_RULO.NORMAL.KIRMIZI_ROTA.toplam,

      MOR_ALT,
      MOR_MAKINA,
      MOR_UST,
      MOR_TOPLAM,
    };

    // Final genel toplam
    FH_RULO_ANALIZ.TOPLAM =
      FH_RULO_ANALIZ.YESIL_ROTA +
      FH_RULO_ANALIZ.KIRMIZI_ROTA +
      FH_RULO_ANALIZ.MOR_TOPLAM;
    // ============================
    // 🟣 YENİ ANALİZLER
    // 1) FABRIKA (1. Kalite Üretim Stok)
    // 2) MÜŞTERİ OPSİYONLU (diğer cariler)
    // ============================

    // FULLHARD rulo datası
    const fhDataFabrika = fhData.filter(
      (r) => normalizeText(r["Cari Ünvanı"]) === "1 KALITE URETIM STOK"
    );

    const fhDataMusteri = fhData.filter(
      (r) => normalizeText(r["Cari Ünvanı"]) !== "1 KALITE URETIM STOK"
    );

    // Ortak hesaplama helper
    const calcFH = (arr) => {
      return {
        YESIL_ROTA: arr
          .filter(
            (r) =>
              num(r.Kalınlık) >= 0.54 &&
              num(r.Kalınlık) <= 1.2 &&
              isUsable(r["Gorunum3"] || "")
          )
          .reduce((a, r) => a + num(r.Kg || r.ToplamKg), 0),

        KIRMIZI_ROTA: arr
          .filter(
            (r) => num(r.Kalınlık) >= 1.21 && isUsable(r["Gorunum3"] || "")
          )
          .reduce((a, r) => a + num(r.Kg || r.ToplamKg), 0),

        MOR_ALT: arr
          .filter(
            (r) => num(r.Kalınlık) <= 0.53 && isUnusable(r["Gorunum3"] || "")
          )
          .reduce((a, r) => a + num(r.Kg || r.ToplamKg), 0),

        MOR_MAKINA: arr
          .filter(
            (r) => num(r.Kalınlık) <= 0.53 && isUsable(r["Gorunum3"] || "")
          )
          .reduce((a, r) => a + num(r.Kg || r.ToplamKg), 0),

        MOR_UST: arr
          .filter(
            (r) => num(r.Kalınlık) >= 0.54 && isUnusable(r["Gorunum3"] || "")
          )
          .reduce((a, r) => a + num(r.Kg || r.ToplamKg), 0),
      };
    };

    // FABRİKA (1.Kalite)
    FH_RULO_ANALIZ.FABRIKA = calcFH(fhDataFabrika);
    FH_RULO_ANALIZ.FABRIKA.MOR_TOPLAM =
      FH_RULO_ANALIZ.FABRIKA.MOR_ALT +
      FH_RULO_ANALIZ.FABRIKA.MOR_MAKINA +
      FH_RULO_ANALIZ.FABRIKA.MOR_UST;
    FH_RULO_ANALIZ.FABRIKA.TOPLAM =
      FH_RULO_ANALIZ.FABRIKA.YESIL_ROTA +
      FH_RULO_ANALIZ.FABRIKA.KIRMIZI_ROTA +
      FH_RULO_ANALIZ.FABRIKA.MOR_TOPLAM;

    // MÜŞTERİ OPSİYONLU (1.kalite olmayanlar)
    FH_RULO_ANALIZ.MUSTERI_OPSIYONLU = calcFH(fhDataMusteri);
    FH_RULO_ANALIZ.MUSTERI_OPSIYONLU.MOR_TOPLAM =
      FH_RULO_ANALIZ.MUSTERI_OPSIYONLU.MOR_ALT +
      FH_RULO_ANALIZ.MUSTERI_OPSIYONLU.MOR_MAKINA +
      FH_RULO_ANALIZ.MUSTERI_OPSIYONLU.MOR_UST;
    FH_RULO_ANALIZ.MUSTERI_OPSIYONLU.TOPLAM =
      FH_RULO_ANALIZ.MUSTERI_OPSIYONLU.YESIL_ROTA +
      FH_RULO_ANALIZ.MUSTERI_OPSIYONLU.KIRMIZI_ROTA +
      FH_RULO_ANALIZ.MUSTERI_OPSIYONLU.MOR_TOPLAM;

    // ============================
    // 🟩 RULO
    // ============================
    const crRulo = sumByCari(rulo, (r) => matchTur(r["Tür"], "SOGUK"));
    const grRulo = sumByCari(rulo, (r) => matchTur(r["Tür"], "GALVANIZ"));
    const zmRulo = sumByCari(rulo, (r) => matchTur(r["Tür"], "MAGNELIS"));
    const hrRulo = sumByCari(rulo, (r) => matchTur(r["Tür"], "SICAK"));
    const ganilRulo = sumByCari(rulo, (r) => matchTur(r["Tür"], "GALVANIL"));

    // ============================
    // 🟦 BAND
    // ============================
    const crBand = sumByCari(band, (r) => matchTur(r["Tür"], "SOGUK"));
    const grBand = sumByCari(band, (r) => matchTur(r["Tür"], "GALVANIZ"));
    const zmBand = sumByCari(band, (r) => matchTur(r["Tür"], "MAGNELIS"));
    const hrBand = sumByCari(
      band,
      (r) => matchTur(r["Tür"], "SICAK") || matchTur(r["Tür"], "ASITLI")
    );
    const ganilBand = sumByCari(band, (r) => matchTur(r["Tür"], "GALVANIL"));
    const bandForFH = JSON.parse(JSON.stringify(band));

    const fhBand = sumByCari(bandForFH, (r) => {
      const turMatch = matchTur(r["Tür"], "FULLHARD");

      const kalinlik = Number(String(r["Kalınlık"]).replace(",", "."));
      const cariNorm = normalizeText(r["Cari Ünvanı"]);
      const hedef = "1 KALITE URETIM STOK";

      // DENEME KURALI → sadece FULLHARD olanlara uygulanır
      const isDeneme = turMatch && kalinlik <= 0.53 && cariNorm === hedef;

      if (isDeneme) {
        r["Cari Ünvanı"] = "DENEME ÜRETİM";
      }

      return turMatch || isDeneme;
    });

    // ============================================
    // 🟣 PROFİL — GÖRÜNÜM DAĞILIMI (KG)
    // ============================================

    const profilFiltered = profil.filter(
      (r) => normalizeText(r["Cari Ünvanı"]) === "1 KALITE URETIM STOK"
    );

    // Eğer hiç yoksa boş obje dön
    if (!profilFiltered.length) {
      return {
        KIMYASAL: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
        MEKANIK: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
        PASLI: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
        MAKINA: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
        TEMIZ: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
      };
    }

    // ==========================
    // GRUP ANAHTARLARI
    // ==========================
    const TUR_KEY = {
      SOGUK: "CR",
      GALVANIZ: "GR",
      SICAK: "HR",
      MAGNELIS: "ZM",
      GALVANIL: "GANIL",
    };

    // ==========================
    // GRUPLAR
    // ==========================
    const GRUPLAR = {
      KIMYASAL: [
        "KİMYASAL YÜKSEK (C)",
        "KİMYASAL YÜKSEK ( C )",
        "KİMYASAL YÜKSEK ( C )-",
        "KİMYASAL YÜKSEK ( Cr )",
        "KİMYASAL YÜKSEK ( Mn )",
        "KİMYASAL YÜKSEK ( Si )",
        "KİMYASAL ÖZ. YÜKSEK",
        "KİMYASAL ÖZ. YÜKSEK - (U2)",
        "KİMYASAL ÖZ. YÜKSEK-",
        "-KİMYASAL YÜKSEK ( C )",
        "KİMYASAL ÖZ. YÜKSEK - (U2)-",
        "KİMYASAL YÜKSEK (Si)",
        "-KİMYASAL YÜKSEK (Si)",
      ],
      MEKANIK: [
        "MEKANİK TEST YÜKSEK",
        "SERT MALZEME (KİMYASAL VE MEKANİK YÜKSEK)",
        "SERT MALZEME (MEKANİK VE KİMYASAL YÜKSEK) - (U1)",
      ],
      PASLI: [
        "BEYAZ PAS",
        "1. DERECE (PAS)",
        "1. DERECE (PAS) - (Y7)",
        "2. DERECE (BÖLGESEL PAS)",
        "2. DERECE (BÖLGESEL PAS) - (Y45)",
        "3. DERECE (NOKTA NOKTA PAS)",
        "3. DERECE (NOKTA NOKTA PAS) - (Y46)",
        "3. DERECE (NOKTA NOKTA PAS)-",
        "-3. DERECE (NOKTA NOKTA PAS)",
        "TAV YANIĞI (MENEVİŞ RENK)",
        "SİYAH LEKE",
        "SİYAH LEKE-",
        "SİYAH LEKE - (Y10)",
        "ÇİZİK",
        "KIRIK",
      ],
      MAKINA: [
        "TAV YANIĞI (MENEVİŞ RENK) - (Y9)",
        "BOY TOLERANS DIŞI (UZUN) - (B2)",
        "KIRIK - (Y11)",
        "EBAT TOLERANS DIŞI",
        "ET KALINLIĞI TOLERANS DIŞI",
        "BOY TOLERANS DIŞI (UZUN-KISA)",
        "BOY TOLERANS DIŞI (UZUN)",
        "BOY TOLERANS DIŞI (KISA)",
        "BOY TOLERANS DIŞI (KISA) - (B3)",
        "EĞRİLİK TOLERANS DIŞI",
        "EĞRİLİK TOLERANS DIŞI - (E)",
        "RADYÜS TOLERANS DIŞI",
        "AĞIZ DİKLİĞİNDEN SAPMA",
        "İÇ-DIŞ BÜKEYLİK TOLERANS DIŞI",
        "DIŞ YÜZEY GR - İÇ YÜZEY SOĞUK -",
        "BURULMA PROBLEMİ",
        "OVALİTE PROBLEMİ",
        "KAYNAKTA BİNDİRME",
        "KAYNAK YÜZEYİ BOZUK",
        "KALIP İZİ - (Y1)",
        "BOY TOLERANS DIŞI (UZUN-KISA) - (B1)",
        "EZME TESTİNDE AÇMA - (A2)",
        "POTLU",
        "POTLU - (A6)",
        "ŞİŞİRME TESTİNDE AÇMA",
        "ŞİŞİRME TESTİNDE AÇMA - (A1)",
        "EZME TESTİNDE AÇMA",
        "BÜKME TESTİNDE AÇMA",
        "KALIP İZİ",
        "MENGENE İZİ",
        "MENGENE İZİ - (Y3)",
        "YARIMAMÜL KAYNAKLI ÇİZİK",
        "YARIMAMÜL KAYNAKLI ÇİZİK - (Y2)",
        "ÇİZİK",
        "OLUK VE EZİK",
        "TESTERE DEFORMASYON",
        "TESTERE DEFORMASYON - (T2)",
        "DEFORMASYON (ÇARPMA-TAŞIMA)",
        "TESTERE ÇAPAK",
        "PÜSKÜRTME ZAYIF",
        "PÜSKÜRTMESİZ (GR TEL)",
        "PÜSKÜRTMELİ (GR TEL)",
        "PÜSKÜRTME KALKMASI",
        "EZME-BÜKMEDE MALZEMEDEN YIRTILMA",
        "YETERSİZ SÜZDÜRME",
        "YÜKLEME PROBLEMLERİ",
        "KAYNAK CÜRUF (B/P İÇİNDE KAYNAK AKINTISI)",
        "KAYNAKTA EKSENEL KAYMA",
      ],
    };

    // ==========================
    // GRUPLAR_SET
    // ==========================
    const GRUPLAR_SET = {
      KIMYASAL: new Set(GRUPLAR.KIMYASAL.map(cleanG)),
      MEKANIK: new Set(GRUPLAR.MEKANIK.map(cleanG)),
      PASLI: new Set(GRUPLAR.PASLI.map(cleanG)),
      MAKINA: new Set(GRUPLAR.MAKINA.map(cleanG)),
    };

    // ==========================
    // kategoriBul
    // ==========================
    const kategoriBul = (gor) => {
      const g = cleanG(gor);
      if (GRUPLAR_SET.KIMYASAL.has(g)) return "KIMYASAL";
      if (GRUPLAR_SET.MEKANIK.has(g)) return "MEKANIK";
      if (GRUPLAR_SET.PASLI.has(g)) return "PASLI";
      if (GRUPLAR_SET.MAKINA.has(g)) return "MAKINA";
      return "TEMIZ";
    };

    // ==========================
    // GÖRÜNÜM GRUPLAMA (final)
    // ==========================
    const profilGorunum = {
      KIMYASAL: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
      MEKANIK: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
      PASLI: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
      MAKINA: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
      TEMIZ: { CR: 0, GR: 0, HR: 0, ZM: 0, GANIL: 0 },
    };

    profilFiltered.forEach((r) => {
      const turNorm = normalizeText(r["Tür"]); // SOGUK / GALVANIZ / SICAK...
      const kol = TUR_KEY[turNorm];
      if (!kol) return;

      const kategori = kategoriBul(r["Gorunum"]);
      profilGorunum[kategori][kol] += num(r.Kg || r.ToplamKg);
    });

    // ============================
    // 🟣 MÜŞTERİ OPSİYONLU
    // ============================
    const tipler = ["SOGUK", "GALVANIZ", "SICAK", "MAGNELIS", "GALVANIL"];

    const profilMusteriOpsiyonlu = (() => {
      const sonuc = {};
      const temizProfil = profil.filter(
        (r) => normalizeText(r["Cari Ünvanı"]) !== "1 KALITE URETIM STOK"
      );
      const cariler = [
        ...new Set(
          temizProfil
            .map((r) => normalizeText(r["Cari Ünvanı"]))
            .filter(Boolean)
        ),
      ];
      for (const cari of cariler) {
        const satir = { cari };
        for (const tip of tipler) {
          const key =
            tip === "SOGUK"
              ? "CR"
              : tip === "GALVANIZ"
                ? "GR"
                : tip === "SICAK"
                  ? "HR"
                  : tip === "MAGNELIS"
                    ? "ZM"
                    : "GANIL";
          satir[key] = temizProfil
            .filter(
              (r) =>
                normalizeText(r["Cari Ünvanı"]) === cari &&
                normalizeText(r["Tür"]).includes(tip)
            )
            .reduce((t, r) => t + num(r.Kg || r.ToplamKg), 0);
        }
        sonuc[cari] = satir;
      }
      return {
        CARILER: Object.values(sonuc),
        TOPLAM: tipler.reduce((acc, tip) => {
          const key =
            tip === "SOGUK"
              ? "CR"
              : tip === "GALVANIZ"
                ? "GR"
                : tip === "SICAK"
                  ? "HR"
                  : tip === "MAGNELIS"
                    ? "ZM"
                    : "GANIL";
          acc[key] = Object.values(sonuc).reduce(
            (t, s) => t + (s[key] || 0),
            0
          );
          return acc;
        }, {}),
      };
    })();

    // ============================
    // 🔚 RETURN
    // ============================
    return {
      RULO: {
        CR: crRulo,
        GR: grRulo,
        ZM: zmRulo,
        HR: hrRulo,
        GANIL: ganilRulo,
        FH_RULO,
        FH_RULO_ANALIZ,
      },
      BAND: {
        CR: crBand,
        GR: grBand,
        ZM: zmBand,
        HR: hrBand,
        GANIL: ganilBand,
        FH: fhBand,
      },
      PROFIL: {
        PROFIL_GORUNUM: profilGorunum,
        MUSTERI_OPSIYONLU: profilMusteriOpsiyonlu,
      },
    };
  }

  function applyCenterAlignment(ws) {
    ws.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true,
        };
      });
    });
  }

  function createStokOzetSheet(stokOzet) {
    if (!stokOzet) return;

    const ws = wb.addWorksheet("STOK ÖZET ANALİZ");
    ws.properties.tabColor = { argb: ARGB("#70AD47") };

    const titleRow = ws.addRow(["STOK ÖZET ANALİZ"]);
    titleRow.font = { bold: true, size: 14 };
    titleRow.alignment = { horizontal: "center" };
    ws.mergeCells(1, 1, 1, 20);

    ws.mergeCells(2, 1, 2, 20);
    const ruloMain = ws.getCell(2, 1);
    ruloMain.value = "RULO STOK DAĞILIMI (KG)";
    ruloMain.font = { bold: true, size: 13 };
    ruloMain.alignment = { horizontal: "center", vertical: "middle" };

    const ruloData = stokOzet.RULO || {};
    const FH_RULO = ruloData.FH_RULO || {};
    const MOR_ROTA = FH_RULO.MOR_ROTA || {};
    const NORMAL = FH_RULO.NORMAL || {};

    const ruloBlocks = [
      {
        title: "CR RULO STOK DAĞILIMI (KG)",
        color: ARGB("#1F4E78"),
        data: ruloData.CR,
      },
      {
        title: "GR RULO STOK DAĞILIMI (KG)",
        color: ARGB("#595959"),
        data: ruloData.GR,
      },
      {
        title: "ZM RULO STOK DAĞILIMI (KG)",
        color: ARGB("#9DC3E6"),
        data: ruloData.ZM,
      },
      {
        title: "HR RULO STOK DAĞILIMI (KG)",
        color: ARGB("#FFD966"),
        data: ruloData.HR,
      },
      {
        title: "GALVANİL RULO STOK DAĞILIMI (KG)",
        color: ARGB("#F4B183"),
        data: ruloData.GANIL,
      },
      {
        title:
          "0.53 MM VE ALTINDAKİ KALINLIKTA RULO KAYNAKLI KULLANILAMAZ RULOLAR (MOR ROTA)",
        color: ARGB("#7030A0"),
        data: MOR_ROTA.ALT_KULLANILAMAZ,
      },
      {
        title:
          "0.53 MM VE ALTINDAKİ KALINLIKTA MAKİNA KAYNAKLI KULLANILAMAZ RULOLAR",
        color: ARGB("#7030A0"),
        data: NORMAL.ALT_KULLANILABILIR,
      },
      {
        title:
          "0.54 MM VE ÜSTÜNDEKİ KALINLIKTA KULLANILAMAZ RULOLAR (MOR ROTA)",
        color: ARGB("#7030A0"),
        data: MOR_ROTA.UST_KULLANILAMAZ,
      },
      {
        title: "0.54 MM VE ÜSTÜNDEKİ KALINLIKTA KULLANILABİLİR RULOLAR",
        color: ARGB("#C00000"),
        data: NORMAL.KIRMIZI_ROTA,
      },
      {
        title:
          "0.54 MM VE ÜSTÜNDEKİ KALINLIKTA KULLANILABİLİR RULOLAR (YEŞİL ROTA)",
        color: ARGB("#92D050"),
        data: NORMAL.YESIL_ROTA,
      },
    ];

    let startCol = 1;
    let maxRowCount = 0;

    ruloBlocks.forEach((b) => {
      const list = (b.data?.cariler || []).filter((x) => x && x.cari);
      if (list.length > maxRowCount) maxRowCount = list.length;
    });

    ruloBlocks.forEach((b) => {
      ws.mergeCells(3, startCol, 3, startCol + 1);
      const cell = ws.getCell(3, startCol);
      cell.value = b.title;
      cell.font = { bold: true, color: { argb: COLORS.WHITE }, size: 10 };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: false,
        shrinkToFit: true,
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: b.color },
      };

      ws.getColumn(startCol).width = 55;
      ws.getColumn(startCol + 1).width = 14;

      const col1 = startCol;
      const col2 = startCol + 1;
      const list = (b.data?.cariler || []).filter(
        (x) => x && x.cari && x.kg >= 0
      );

      let row = 4;
      for (const item of list) {
        ws.getCell(row, col1).value = item.cari;
        ws.getCell(row, col2).value = item.kg;
        row++;
      }

      for (let i = list.length; i < maxRowCount; i++) {
        ws.getCell(row, col1).value = "";
        ws.getCell(row, col2).value = "";
        row++;
      }

      ws.getCell(row, col1).value = "TOPLAM";
      ws.getCell(row, col2).value = b.data?.toplam || 0;
      ws.getCell(row, col1).font = { bold: true };
      ws.getCell(row, col2).font = { bold: true };
      [col1, col2].forEach((c) => {
        ws.getCell(row, c).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: COLORS.TOTAL },
        };
      });

      startCol += 2;
    });

    const bandStart = maxRowCount + 6;
    ws.mergeCells(bandStart, 1, bandStart, 12);
    const bandMain = ws.getCell(bandStart, 1);
    bandMain.value = "BAND STOK DAĞILIMI (KG)";
    bandMain.font = { bold: true, size: 13 };
    bandMain.alignment = { horizontal: "center", vertical: "middle" };

    const bandData = stokOzet.BAND || {};
    const bandBlocks = [
      {
        title: "CR BAND STOK DAĞILIMI (KG)",
        color: ARGB("#1F4E78"),
        data: bandData.CR,
      },
      {
        title: "GR BAND STOK DAĞILIMI (KG)",
        color: ARGB("#595959"),
        data: bandData.GR,
      },
      {
        title: "ZM BAND STOK DAĞILIMI (KG)",
        color: ARGB("#9DC3E6"),
        data: bandData.ZM,
      },
      {
        title: "HR BAND STOK DAĞILIMI (KG)",
        color: ARGB("#FFD966"),
        data: bandData.HR,
      },
      {
        title: "GALVANİL BAND STOK DAĞILIMI (KG)",
        color: ARGB("#F4B183"),
        data: bandData.GANIL,
      },
      {
        title: "FULLHARD BAND STOK DAĞILIMI (KG)",
        color: ARGB("#C00000"),
        data: bandData.FH,
      },
    ];

    let bStartCol = 1;
    let bMaxCount = 0;

    bandBlocks.forEach((b) => {
      const list = (b.data?.cariler || []).filter((x) => x && x.cari);
      if (list.length > bMaxCount) bMaxCount = list.length;
    });

    bandBlocks.forEach((b) => {
      ws.mergeCells(bandStart + 1, bStartCol, bandStart + 1, bStartCol + 1);
      const cell = ws.getCell(bandStart + 1, bStartCol);
      cell.value = b.title;
      cell.font = { bold: true, color: { argb: COLORS.WHITE }, size: 10 };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: false,
        shrinkToFit: true,
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: b.color },
      };

      ws.getColumn(bStartCol).width = 55;
      ws.getColumn(bStartCol + 1).width = 14;

      const col1 = bStartCol;
      const col2 = bStartCol + 1;

      const list = (b.data?.cariler || []).filter(
        (x) => x && x.cari && x.kg >= 0
      );

      let row = bandStart + 2;

      for (const item of list) {
        let cariText = item.cari;

        if (b.title === "FULLHARD BAND STOK DAĞILIMI (KG)") {
          // RAW band datasında FULLHARD & aynı cari olan satırları bul
          const rawMatch = band.find(
            (r) =>
              r["Tür"] === "FULLHARD" &&
              r["Cari Ünvanı"] === "1 KALİTE ÜRETİM STOK"
          );

          // Kalınlığı al
          let kalinlik = null;
          if (rawMatch) {
            kalinlik = Number(
              String(rawMatch["Kalınlık"] || "").replace(",", ".")
            );
          }

          if (kalinlik !== null) {
            if (kalinlik <= 0.53) {
              cariText = "DENEME ÜRETİM";
            } else {
              cariText = "1 KALİTE ÜRETİM STOK";
            }
          }
        }

        ws.getCell(row, col1).value = cariText;
        ws.getCell(row, col2).value = item.kg;
        row++;
      }

      for (let i = list.length; i < bMaxCount; i++) {
        ws.getCell(row, col1).value = "";
        ws.getCell(row, col2).value = "";
        row++;
      }

      ws.getCell(row, col1).value = "TOPLAM";
      ws.getCell(row, col2).value = b.data?.toplam || 0;
      ws.getCell(row, col1).font = { bold: true };
      ws.getCell(row, col2).font = { bold: true };
      [col1, col2].forEach((c) => {
        ws.getCell(row, c).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: COLORS.TOTAL },
        };
      });

      bStartCol += 2;
    });

    if (stokOzet.PROFIL) {
      const topRow = bandStart + bMaxCount + 4;

      ws.mergeCells(topRow, 1, topRow, 6);
      const leftTitle = ws.getCell(topRow, 1);
      leftTitle.value = "PROFİL GÖRÜNÜM DAĞILIMI (KG)";
      leftTitle.font = { bold: true, size: 13 };
      leftTitle.alignment = { horizontal: "center", vertical: "middle" };

      ws.mergeCells(topRow, 7, topRow, 12);
      const rightTitle = ws.getCell(topRow, 7);
      rightTitle.value = "MÜŞTERİ OPSİYONLU BORU-PROFİL DAĞILIMI (KG)";
      rightTitle.font = { bold: true, size: 13 };
      rightTitle.alignment = { horizontal: "center", vertical: "middle" };

      const headerRow = topRow + 1;

      const leftHeaders = ["Görünüm", "CR", "GR", "HR", "ZM", "GALVANİL"];
      leftHeaders.forEach((h, i) => (ws.getCell(headerRow, 1 + i).value = h));
      setHeaderStyle(ws.getRow(headerRow), ARGB("#70AD47"));

      const rightHeaders = ["Cari Adı", "CR", "GR", "HR", "ZM", "GALVANİL"];
      rightHeaders.forEach((h, i) => (ws.getCell(headerRow, 7 + i).value = h));
      setHeaderStyle(ws.getRow(headerRow), ARGB("#2F75B5"));

      const renameMap = {
        KIMYASAL: "KİMYASAL ÖZELLİKLERİ UYGUN OLMAYANLAR",
        MEKANIK: "MEKANİK ÖZELLİKLERİ UYGUN OLMAYANLAR",
        PASLI: "PASLI ÜRÜNLER",
        MAKINA: "MAKİNA KAYNAKLI / DİĞER PROBLEMLİ ÜRÜNLER",
        TEMIZ: "TEMİZ ÜRÜNLER",
      };

      const gorunum = stokOzet.PROFIL.PROFIL_GORUNUM || {};
      let leftRow = headerRow + 1;

      Object.entries(gorunum).forEach(([key, obj]) => {
        ws.getCell(leftRow, 1).value = renameMap[key] || key;
        ws.getCell(leftRow, 2).value = obj.CR || 0;
        ws.getCell(leftRow, 3).value = obj.GR || 0;
        ws.getCell(leftRow, 4).value = obj.HR || 0;
        ws.getCell(leftRow, 5).value = obj.ZM || 0;
        ws.getCell(leftRow, 6).value = obj.GANIL || 0;
        leftRow++;
      });

      for (let col = 1; col <= 6; col++) {
        const cell = ws.getCell(leftRow, col);

        cell.font = { bold: true, color: { argb: "FF000000" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD9D9D9" }, // aynı gri
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
          bottom: { style: "thin" },
        };
      }

      ws.getCell(leftRow, 1).value = "TOPLAM";
      ws.getCell(leftRow, 1).font = { bold: true };

      ws.getCell(leftRow, 2).value = Object.values(gorunum).reduce(
        (a, o) => a + (o.CR || 0),
        0
      );
      ws.getCell(leftRow, 3).value = Object.values(gorunum).reduce(
        (a, o) => a + (o.GR || 0),
        0
      );
      ws.getCell(leftRow, 4).value = Object.values(gorunum).reduce(
        (a, o) => a + (o.HR || 0),
        0
      );
      ws.getCell(leftRow, 5).value = Object.values(gorunum).reduce(
        (a, o) => a + (o.ZM || 0),
        0
      );
      ws.getCell(leftRow, 6).value = Object.values(gorunum).reduce(
        (a, o) => a + (o.GANIL || 0),
        0
      );

      // Kenarlık + Bold
      ws.getRow(leftRow).eachCell((c) => {
        c.font = { bold: true };
        c.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
          bottom: { style: "thin" },
        };
      });

      const cariler = stokOzet.PROFIL.MUSTERI_OPSIYONLU?.CARILER || [];
      let rightRow = headerRow + 1;

      cariler.forEach((m) => {
        ws.getCell(rightRow, 7).value = m.cari;
        ws.getCell(rightRow, 8).value = m.CR || 0;
        ws.getCell(rightRow, 9).value = m.GR || 0;
        ws.getCell(rightRow, 10).value = m.HR || 0;
        ws.getCell(rightRow, 11).value = m.ZM || 0;
        ws.getCell(rightRow, 12).value = m.GANIL || 0;
        rightRow++;
      });

      const toplam = stokOzet.PROFIL.MUSTERI_OPSIYONLU?.TOPLAM || {};
      ws.getCell(rightRow, 7).value = "TOPLAM";
      ws.getCell(rightRow, 8).value = toplam.CR || 0;
      ws.getCell(rightRow, 9).value = toplam.GR || 0;
      ws.getCell(rightRow, 10).value = toplam.HR || 0;
      ws.getCell(rightRow, 11).value = toplam.ZM || 0;
      ws.getCell(rightRow, 12).value = toplam.GANIL || 0;

      const applyRightSummaryRowStyle = (rowNumber) => {
        [7, 8, 9, 10, 11, 12].forEach((c) => {
          ws.getCell(rowNumber, c).font = { bold: true };
          ws.getCell(rowNumber, c).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.TOTAL },
          };
          ws.getCell(rowNumber, c).border = {
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
            bottom: { style: "thin" },
          };
        });
      };

      applyRightSummaryRowStyle(rightRow);

      rightRow++;
      ws.getCell(rightRow, 7).value = "İÇ PİYASA";
      applyRightSummaryRowStyle(rightRow);

      rightRow++;
      ws.getCell(rightRow, 7).value = "İHRACAT";
      applyRightSummaryRowStyle(rightRow);

      [rightRow - 2, rightRow - 1, rightRow].forEach((rowNumber) => {
        [7, 8, 9, 10, 11, 12].forEach((c) => {
          ws.getCell(rowNumber, c).alignment = {
            horizontal: "center",
            vertical: "middle",
          };
        });
      });
    }

    setFullBorder(ws);
    applyDefaultSizeStok(ws);

    if (stokOzet?.RULO?.FH_RULO_ANALIZ) {
      const fh = stokOzet.RULO.FH_RULO_ANALIZ;
      const fabrika = stokOzet.RULO.FH_RULO_ANALIZ.FABRIKA || {};
      const musteri = stokOzet.RULO.FH_RULO_ANALIZ.MUSTERI_OPSIYONLU || {};

      const fhStartRow = bandStart;
      const fhStartCol = bStartCol + 2;

      // --- ÜST BAŞLIK ---
      ws.mergeCells(fhStartRow, fhStartCol, fhStartRow, fhStartCol + 4);
      const title = ws.getCell(fhStartRow, fhStartCol);
      title.value = "FH RULO ANALİZ (KG)";
      title.font = { bold: true, size: 13 };
      title.alignment = { horizontal: "center", vertical: "middle" };

      // --- HEADER ---
      const hdrRow = fhStartRow + 1;
      ws.getCell(hdrRow, fhStartCol).value = "FULLHARD RULO";
      ws.getCell(hdrRow, fhStartCol + 1).value = "YEŞİL ROTA";
      ws.getCell(hdrRow, fhStartCol + 2).value = "KIRMIZI ROTA";
      ws.getCell(hdrRow, fhStartCol + 3).value = "MOR";
      ws.getCell(hdrRow, fhStartCol + 4).value = "TOPLAM";

      for (let c = fhStartCol; c <= fhStartCol + 4; c++) {
        const cell = ws.getCell(hdrRow, c);
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      }

      ws.getCell(hdrRow, fhStartCol + 1).fill = {
        type: "pattern",
        pattern: "solid",
        bold: true,
        fgColor: { argb: "92D050" },
      };
      ws.getCell(hdrRow, fhStartCol + 2).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF0000" },
      };
      ws.getCell(hdrRow, fhStartCol + 3).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "7030A0" },
      };

      // =============================
      //   3 SATIRLIK YENİ TABLO
      // =============================

      const rows = [
        { label: "1 KALITE URETIM STOK", data: fabrika },
        { label: "MÜŞTERİ OPSİYONLU", data: musteri },
        { label: "TOPLAM", data: fh },
      ];

      let rowIndex = hdrRow + 1;

      rows.forEach((item) => {
        const isToplamRow = item.label === "TOPLAM";

        ws.getCell(rowIndex, fhStartCol).value = item.label;
        ws.getCell(rowIndex, fhStartCol + 1).value = item.data.YESIL_ROTA || 0;
        ws.getCell(rowIndex, fhStartCol + 2).value =
          item.data.KIRMIZI_ROTA || 0;
        ws.getCell(rowIndex, fhStartCol + 3).value = item.data.MOR_TOPLAM || 0;
        ws.getCell(rowIndex, fhStartCol + 4).value = item.data.TOPLAM || 0;

        for (let c = fhStartCol; c <= fhStartCol + 4; c++) {
          const cell = ws.getCell(rowIndex, c);
          cell.alignment = { horizontal: "center", vertical: "middle" };
          if (isToplamRow) {
            cell.font = { ...(cell.font || {}), bold: true };
          }
          if (typeof cell.value === "number") cell.numFmt = "#,##0";
        }

        // FH RULO ANALİZ KG TABLOSU BOLD YAPILID RENK EKLENMEK İSTERSE NOT
        rowIndex++;
      });

      // --- KOLON GENİŞLİKLERİ ---
      for (let c = fhStartCol; c <= fhStartCol + 4; c++) {
        ws.getColumn(c).width = 18;
      }

      setFullBorder(ws);
    }

    setFullBorder(ws);
    applyDefaultSizeStok(ws);
    applyCenterAlignment(ws);
  }

  function buildHammaddeAnaliz(hammadde = []) {
    const CINS_MAP = {
      FULLHARD: "FH",
      SOĞUK: "CR",
      SOGUK: "CR",
      GALVANİZ: "GR",
      MAGNELIS: "ZM",
      SICAK: "HR",
      SICAK_RULO: "HR",
    };

    const grouped = {};

    hammadde.forEach((row) => {
      let kontratRaw = row.MusteriKontratNo;
      let kontrat =
        kontratRaw === undefined ||
        kontratRaw === null ||
        String(kontratRaw).trim() === ""
          ? "KONTRAT YOK"
          : String(kontratRaw).trim();

      const cins = CINS_MAP[row.Cins2] || row.Cins2 || "";
      const tip = row.Tip || "";
      const mensei = row.mensei || "";

      // === TONAJ HESABI ===
      // ToplamKg → ton'a çevir + yuvarlama
      const ton =
        Math.round(
          Number(String(row.ToplamKg).replace(",", ".").replace(" ", "")) / 1000
        ) || 0;

      //  TON 0 ise bu satırı tamamen atla
      if (ton === 0) return;

      const key = `${kontrat}_${mensei}_${cins}_${tip}`;

      if (!grouped[key]) {
        grouped[key] = {
          kontratNo: kontrat,
          mensei,
          cins,
          tip,
          toplamKg: 0,
        };
      }

      grouped[key].toplamKg += ton;
    });

    return Object.values(grouped);
  }

  function buildGelecekDetay(hammadde = []) {
    if (!Array.isArray(hammadde)) return {};

    // CİNS2 → SHEET eşleme
    const CINS_MAP = {
      SOĞUK: "CR GELECEK",
      GALVANİZ: "GR GELECEK",
      FULLHARD: "FH GELECEK",
      MAGNELİS: "MAGNELİS GELECEK",
      SICAK: "HR GELECEK",
      GALVANİL: "GALVANİL GELECEK",
    };

    const result = {
      "CR GELECEK": {},
      "GR GELECEK": {},
      "FH GELECEK": {},
      "MAGNELİS GELECEK": {},
      "HR GELECEK": {},
      "GALVANİL GELECEK": {},
    };

    hammadde.forEach((r) => {
      if (!r.Cins2 && !r.MusteriKontratNo) return;
      const cins = (r.Cins2 || "").toUpperCase();
      const sheetName = CINS_MAP[cins];
      if (!sheetName) return;

      const mensei = (r.mensei || "").toUpperCase();

      if (!result[sheetName][mensei]) {
        result[sheetName][mensei] = [];
      }

      result[sheetName][mensei].push({
        sozlesme: r.MusteriKontratNo || "",
        mensei: r.mensei || "",
        malzeme:
          cins === "SOĞUK"
            ? "CR"
            : cins === "GALVANİZ"
              ? "GR"
              : cins === "MAGNELİS"
                ? "MAGNELİS"
                : cins === "SICAK"
                  ? "HR"
                  : cins === "GALVANİL"
                    ? "GALVANİL"
                    : "FH",
        kalinlik: r.kalinlik || "",
        genislik: r.genislik || "",
        kalite: r.kalite || "",
        kaplama: r.kaplama || "",
        tonaj: r.tonaj || r.ToplamKg || 0,
        gelen: r.gelenKg || 0,
        kalan: (r.tonaj || r.ToplamKg || 0) - (r.gelen || 0),
        gkKalan: (r.tonaj || r.ToplamKg || 0) - (r.gelenKg || 0),
        termin: r.tarih || "",
        tip: r.Tip || "",
      });
    });

    return result;
  }

  function createGelecekSheets(detayData) {
    const sheetColors = {
      "CR GELECEK": "FF1F4E78", // mavi
      "GR GELECEK": "FF7F7F7F", // gri
      "FH GELECEK": "FFC00000", // kırmız
      "MAGNELİS GELECEK": "7F7FFF",
      "HR GELECEK": "FFA500",
      "GALVANİL GELECEK": "FFDBBB",
    };

    const headerColors = {
      "CR GELECEK": "FF1F4E78",
      "GR GELECEK": "FF7F7F7F",
      "FH GELECEK": "FFC00000",
      "MAGNELİS GELECEK": "7F7FFF",
      "HR GELECEK": "FFA500",
      "GALVANİL GELECEK": "FFDBBB",
    };

    const tableHeaders = [
      "SÖZLEŞME",
      "MENŞEİ",
      "MALZEME",
      "KLN",
      "EN",
      "KALİTE",
      "KAPLAMA",
      "TONAJ",
      "GELEN",
      "KALAN",
      "GÖKTAŞ KALAN",
      "REZERV",
      "TERMİN",
    ];

    Object.keys(detayData).forEach((sheetName) => {
      const ws = wb.addWorksheet(sheetName);
      ws.properties.tabColor = { argb: sheetColors[sheetName] };

      let rowIndex = 1;
      const menseiGroups = detayData[sheetName];

      const sortedMenseiEntries = Object.entries(menseiGroups).sort((a, b) => {
        const sozA = Number(a[1][0].sozlesme);
        const sozB = Number(b[1][0].sozlesme);
        return sozA - sozB;
      });

      sortedMenseiEntries.forEach(([mensei, rows]) => {
        // === BAŞLIK ===
        ws.mergeCells(rowIndex, 1, rowIndex, 13);
        const title = ws.getCell(rowIndex, 1);
        title.value = `${mensei} ${rows[0].malzeme} ${rows[0].tip}`;
        title.font = { bold: true, size: 14 };
        title.alignment = { horizontal: "center" };
        rowIndex++;

        // === RENKLİ HEADER ===
        const headerRow = ws.addRow(tableHeaders);
        headerRow.eachCell((c) => {
          c.font = { bold: true, color: { argb: "FFFFFFFF" } };
          c.alignment = { horizontal: "center" };
          c.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
            bottom: { style: "thin" },
          };
          c.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: headerColors[sheetName] },
          };
        });
        rowIndex++;

        // 📌 HEADER ROW INDEX — DATA START
        const headerRowIndex = rowIndex - 1;
        const dataStartRow = rowIndex;

        // === VERİ SATIRLARI — SÖZLEŞME GRUPLU ve TEKRAR HEADER YAZAN YAPI ===

        let lastSozlesme = null;
        rows.sort((a, b) => {
          const A = a.sozlesme;
          const B = b.sozlesme;

          const numA = Number(A);
          const numB = Number(B);

          const isNumA = !isNaN(numA);
          const isNumB = !isNaN(numB);

          // İkisi de sayıysa → doğal numerik sırala
          if (isNumA && isNumB) return numA - numB;

          // İkisi de sayı değilse (25-6476 gibi) → alfabetik sırala
          if (!isNumA && !isNumB) return String(A).localeCompare(String(B));

          // Biri sayı biri string ise → SAYI ÖNDE OLSUN
          if (isNumA) return -1;
          if (isNumB) return 1;

          return 0;
        });

        rows.forEach((r) => {
          const isNewGroup = lastSozlesme !== r.sozlesme;

          if (isNewGroup) {
            // Eğer ilk grup değilse araya boşluk + tekrar başlık + tekrar header
            if (lastSozlesme !== null) {
              ws.addRow([]);
              rowIndex++;

              // === BAŞLIK ===
              ws.mergeCells(rowIndex, 1, rowIndex, 13);
              const subTitle = ws.getCell(rowIndex, 1);
              subTitle.value = `${mensei} ${r.malzeme} ${r.tip}`;
              subTitle.font = { bold: true, size: 14 };
              subTitle.alignment = { horizontal: "center" };
              rowIndex++;

              // === HEADER TEKRAR ===
              const repeatHeader = ws.addRow(tableHeaders);
              repeatHeader.eachCell((c) => {
                c.font = { bold: true, color: { argb: "FFFFFFFF" } };
                c.alignment = { horizontal: "center" };
                c.border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  right: { style: "thin" },
                  bottom: { style: "thin" },
                };
                c.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: headerColors[sheetName] },
                };
              });

              rowIndex++;
            }
          }

          // === DATA ROW ===
          const dataRow = ws.addRow([
            r.sozlesme,
            r.mensei,
            r.malzeme,
            r.kalinlik,
            r.genislik,
            r.kalite,
            r.kaplama,
            r.tonaj,
            r.gelen,
            r.kalan,
            "", // Göktaş kalan
            0, // Rezerv
            r.termin,
          ]);

          const rowNum = dataRow.number;

          // REZERV (L) satırını KALINLIK KIRILIMI bağlantısı için kaydet
          if (!kalinlikKirilimiRefs.rezerv[sheetName]) {
            kalinlikKirilimiRefs.rezerv[sheetName] = {};
          }
          const kKey = kalinlikKey(r.kalinlik);
          if (!kalinlikKirilimiRefs.rezerv[sheetName][kKey]) {
            kalinlikKirilimiRefs.rezerv[sheetName][kKey] = [];
          }
          kalinlikKirilimiRefs.rezerv[sheetName][kKey].push(rowNum);

          if (!kalinlikKirilimiRefs.gelecekRows[sheetName]) {
            kalinlikKirilimiRefs.gelecekRows[sheetName] = [];
          }
          kalinlikKirilimiRefs.gelecekRows[sheetName].push({
            kal: kKey,
            row: rowNum,
            termin: r.termin,
            sozlesme: r.sozlesme,
            mensei: r.mensei,
            tip: r.tip,
          });

          dataRow.getCell(10).value = { formula: `H${rowNum}-I${rowNum}` };
          dataRow.getCell(11).value = { formula: `J${rowNum}-L${rowNum}` };
          dataRow.getCell(11).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFF00" }, // sarıııııııııı
          };

          dataRow.eachCell((c) => {
            c.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
            c.alignment = { horizontal: "center" };
          });

          lastSozlesme = r.sozlesme;
          rowIndex++;
        });

        // 📌 DATA END ROW
        const dataEndRow = rowIndex - 1;

        // === BORDER UYGULA ===

        // HEADER = 4 TARAF KALIN
        applyHeaderThick(ws, headerRowIndex, tableHeaders.length);

        // DATA = SAĞ-SOL KALIN, ÜST-ALT İNCE
        applyDataSideBorders(ws, dataStartRow, dataEndRow, tableHeaders.length);

        // boşluk (bloklar arası 1 satır)
        rowIndex += 1;
        ws.addRow([]);
      });
      [15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 17, 15, 15].forEach((w, i) => {
        ws.getColumn(i + 1).width = w;
      });

      applyGlobalFont(ws);
    });
  }

  function buildSatilabilirKgAnaliz(rulo = [], band = [], profil = []) {
    rulo = JSON.parse(JSON.stringify(rulo));
    band = JSON.parse(JSON.stringify(band));
    profil = JSON.parse(JSON.stringify(profil));

    const clean = (v) =>
      (v || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();

    const isSatilabilir = (row) =>
      clean(row["Cari Ünvanı"]) === clean("--1. KALITE URETIM STOK--") ||
      clean(row["Cari Ünvanı"]) === clean("DENEME ÜRETİM");

    const RULO_MAP = {
      SOGUK: "CR",
      SOĞUK: "CR",
      ASITLI: "ASITLI",
      "SOGUK ASITLI FIRIN": "SOGUK ASITLI FIRIN",
      GALVANIZ: "GR",
      GALVANİZ: "GR",
      MAGNELIS: "ZM",
      MAGNELİS: "ZM",
      SICAK: "HR",
      GALVANIL: "GANIL",
      FULLHARD: "FH",
      "GALVANİZ HADDE": "GALVANIZ HADDE",
      "SOGUK FULLHARD SKINPASS": "FH SKINPASS(CRSF)",
      "SOGUK FULLHARD FIRIN": "FH FIRIN (CFF)",
      "SOGUK FULLHARD HADDE": "FH HADDE (CDF)",
      "SIYAH SKINPASS": "HR SKINPASS (HRS)",
    };
    const BAND_MAP = {
      SOGUK: "CR",
      SOĞUK: "CR",
      FULLHARD: "FH",
      GALVANIZ: "GR",
      GALVANİZ: "GR",
      MAGNELIS: "ZM",
      SICAK: "HR",
      ASITLI: "HR",
      GALVANIL: "GANIL",
      "SOGUK FULLHARD SKINPASS": "FH SKINPASS (BCRSF)",
      "SOGUK HADDE": "CR HADDE (BCD)",
      "SOGUK FULLHARD FIRIN": "FH FIRIN (BCFF)",
      "GALVANİZ HADDE": "GALVANIZ HADDE",
    };
    const PROFIL_MAP = {
      SOGUK: "CR",
      SOĞUK: "CR",
      GALVANIZ: "GR",
      GALVANİZ: "GR",
      MAGNELIS: "ZM",
      SICAK: "HR",
      GALVANIL: "GANIL",
    };

    const getCins = (tur, map) => {
      if (!tur) return "";
      const key = clean(tur);
      return map[key] || key;
    };

    const ruloGroups = {};

    rulo.filter(isSatilabilir).forEach((r) => {
      const cins = getCins(r["Tür"], RULO_MAP);

      const kg = Number(r["ToplamKg"] || 0);

      const ton = kg / 1000;
      ruloGroups[cins] = (ruloGroups[cins] || 0) + ton;
    });
    const ruloToplam = Object.values(ruloGroups).reduce((a, b) => a + b, 0);

    // =========================
    // BAND
    // =========================
    const bandGroups = {};
    band.filter(isSatilabilir).forEach((r) => {
      const cins = getCins(r["Tür"], BAND_MAP);

      const kg = Number(r["ToplamKg"] || 0);

      const ton = kg / 1000;

      bandGroups[cins] = (bandGroups[cins] || 0) + ton;
    });
    const bandToplam = Object.values(bandGroups).reduce((a, b) => a + b, 0);

    // =========================
    // PROFİL
    // =========================
    const profilGroups = {};
    profil.filter(isSatilabilir).forEach((r) => {
      const cins = getCins(r["Tür"], PROFIL_MAP);

      const kg = Number(r["ToplamKg"] || 0);

      const ton = kg / 1000;
      profilGroups[cins] = (profilGroups[cins] || 0) + ton;
    });
    const profilToplam = Object.values(profilGroups).reduce((a, b) => a + b, 0);

    // =========================
    // GENEL TOPLAM
    // =========================
    const genelToplam = ruloToplam + bandToplam + profilToplam;

    return {
      rulo: { detay: ruloGroups, toplam: ruloToplam },
      band: { detay: bandGroups, toplam: bandToplam },
      profil: { detay: profilGroups, toplam: profilToplam },
      genelToplam,
    };
  }

  function createTekSheet(hammaddeGelecek = [], satilabilirAnaliz) {
    const ws = wb.addWorksheet("ANA");
    ws.properties.tabColor = { argb: ARGB("#FF8000FF") };

    // === TARİH ============================================================
    const now = new Date();
    const gun = String(now.getDate()).padStart(2, "0");
    const ay = String(now.getMonth() + 1).padStart(2, "0");
    const yil = now.getFullYear();
    const tarih = `${gun}.${ay}.${yil}`;

    ws.mergeCells(1, 1, 1, 7);
    const title = ws.getCell(1, 1);
    title.value = `GÖKTAŞ STOK DURUM RAPORU ${tarih}`;
    title.alignment = { horizontal: "center" };
    title.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFF00" },
    };
    title.border = {
      top: { style: "thick" },
      bottom: { style: "thick" },
      left: { style: "thick" },
      right: { style: "thick" },
    };
    title.font = { bold: true, size: 16 };
    ws.getRow(1).height = 30;

    let rowCursor = 2;

    // === HEADER ============================================================
    function writeHeader() {
      const header = ws.addRow([
        "KONTRAT NO",
        "MENŞEİ",
        "CİNS",
        "TİP",
        "MİKTAR",
        "SATIŞ",
        "YORUMLAR",
      ]);

      header.eachCell((c) => {
        c.font = { bold: true };
        c.alignment = { horizontal: "center" };
        c.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
          bottom: { style: "thin" },
        };
        c.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD9D9D9" },
        };
      });

      ws.getColumn(1).width = 20;
      ws.getColumn(2).width = 20;
      ws.getColumn(3).width = 35;
      ws.getColumn(4).width = 18;
      ws.getColumn(5).width = 17;
      ws.getColumn(6).width = 12;
      ws.getColumn(7).width = 25;
    }

    // === SAĞ TONAJ ÖZET TABLOSU I3:L6 ====================================
    const tonajSummaryRows = {
      stok: {
        soguk: [],
        galvaniz: [],
        sicak: [],
      },
      gelecek: {
        soguk: [],
        galvaniz: [],
        sicak: [],
      },
    };

    function cleanSummaryText(value) {
      return String(value || "")
        .toLocaleUpperCase("tr-TR")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[().,-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    function getStokSummaryGroup(cins, tip) {
      const c = cleanSummaryText(cins);
      const t = cleanSummaryText(tip);

      // BORU-PRF / PROFİL bu tabloda istenmediği için dışarıda bırakıyoruz
      if (t === "BORU PRF" || t === "BORU PROFIL" || t === "BP") {
        return null;
      }

      // SOĞUK:
      // CR RULO/BAND
      // FH RULO/BAND
      // CFF RULO
      // CDF RULO
      // CRSF RULO
      // BCFF BAND
      // BCRSF BAND
      // BCD BAND
      if (
        c === "CR" ||
        c === "FH" ||
        c.includes("CFF") ||
        c.includes("CDF") ||
        c.includes("CRSF") ||
        c.includes("BCFF") ||
        c.includes("BCRSF") ||
        c.includes("BCD")
      ) {
        return "soguk";
      }

      // GALVANİZ:
      // GR RULO/BAND
      // GALVANİZ HADDE RULO/BAND
      if (c === "GR" || c.includes("GALVANIZ HADDE")) {
        return "galvaniz";
      }

      // SICAK:
      // HR RULO/BAND
      if (c === "HR" || c === "ASITLI" || c === "SOGUK ASITLI FIRIN") {
        return "sicak";
      }

      return null;
    }

    function getGelecekSummaryGroup(cins) {
      const c = cleanSummaryText(cins);

      // GELECEK SOĞUK: CR + FH
      if (c === "CR" || c === "FH") {
        return "soguk";
      }

      // GELECEK GALVANİZ: GR
      if (c === "GR") {
        return "galvaniz";
      }

      // GELECEK SICAK: HR
      if (c === "HR") {
        return "sicak";
      }

      return null;
    }

    function makeSummaryFormula(rows, columnLetter) {
      if (!rows.length) return "0";
      return rows.map((rowNo) => `${columnLetter}${rowNo}`).join("+");
    }

    function styleSummaryRange() {
      const thinBlackBorder = {
        style: "thin",
        color: { argb: "FF000000" },
      };

      // Önce bütün tabloya temel görünüm
      for (let row = 3; row <= 6; row++) {
        for (let col = 9; col <= 12; col++) {
          const cell = ws.getCell(row, col);

          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
          };

          cell.border = {
            top: thinBlackBorder,
            left: thinBlackBorder,
            right: thinBlackBorder,
            bottom: thinBlackBorder,
          };

          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFFFF" },
          };

          cell.font = {
            name: "Arial",
            bold: true,
            size: 11,
            color: { argb: "FF000000" },
          };

          if (col >= 10) {
            cell.numFmt = "0";
          }
        }
      }

      // SATILABİLİR MALZEME TONAJLARI
      ws.getCell("I3").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF000000" },
      };
      ws.getCell("I3").font = {
        name: "Arial",
        bold: true,
        size: 10,
        color: { argb: "FFFFFFFF" },
      };

      // SOĞUK
      ws.getCell("J3").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF12A8D8" },
      };
      ws.getCell("J3").font = {
        name: "Arial",
        bold: true,
        size: 11,
        color: { argb: "FF000000" },
      };

      // GALVANİZ
      ws.getCell("K3").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD9D9D9" },
      };
      ws.getCell("K3").font = {
        name: "Arial",
        bold: true,
        size: 11,
        color: { argb: "FF000000" },
      };

      // SICAK
      ws.getCell("L3").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF0000" },
      };
      ws.getCell("L3").font = {
        name: "Arial",
        bold: true,
        size: 11,
        color: { argb: "FF000000" },
      };

      // STOK
      ws.getCell("I4").font = {
        name: "Arial",
        bold: true,
        size: 11,
        color: { argb: "FF000000" },
      };

      // GELECEK — yeşil yazı
      ws.getCell("I5").font = {
        name: "Arial",
        bold: true,
        size: 11,
        color: { argb: "FF00B050" },
      };

      // TOTAL satırının tamamı siyah
      for (let col = 9; col <= 12; col++) {
        const cell = ws.getCell(6, col);

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF000000" },
        };

        cell.font = {
          name: "Arial",
          bold: true,
          size: 11,
          color: { argb: "FFFFFFFF" },
        };
      }

      ws.getRow(3).height = 24;
      ws.getRow(4).height = 21;
      ws.getRow(5).height = 21;
      ws.getRow(6).height = 21;
    }

    function writeTonajSummaryTable() {
      ws.getColumn(9).width = 34; // I
      ws.getColumn(10).width = 14; // J
      ws.getColumn(11).width = 14; // K
      ws.getColumn(12).width = 14; // L

      ws.getCell("I3").value = "SATILABİLİR MALZEME TONAJLARI";
      ws.getCell("J3").value = "SOĞUK";
      ws.getCell("K3").value = "GALVANİZ";
      ws.getCell("L3").value = "SICAK";

      ws.getCell("I4").value = "STOK";
      ws.getCell("I5").value = "GELECEK";
      ws.getCell("I6").value = "TOTAL";

      // Açıklama notları (hücre üzerine gelince görünür)
      ws.getCell("J3").note = "SOĞUK = CR + FH";
      ws.getCell("I4").note = "STOK = RULO + BAND";

      ws.getCell("J4").value = {
        formula: makeSummaryFormula(tonajSummaryRows.stok.soguk, "E"),
      };
      ws.getCell("K4").value = {
        formula: makeSummaryFormula(tonajSummaryRows.stok.galvaniz, "E"),
      };
      ws.getCell("L4").value = {
        formula: makeSummaryFormula(tonajSummaryRows.stok.sicak, "E"),
      };

      ws.getCell("J5").value = {
        formula: makeSummaryFormula(tonajSummaryRows.gelecek.soguk, "E"),
      };
      ws.getCell("K5").value = {
        formula: makeSummaryFormula(tonajSummaryRows.gelecek.galvaniz, "E"),
      };
      ws.getCell("L5").value = {
        formula: makeSummaryFormula(tonajSummaryRows.gelecek.sicak, "E"),
      };

      ws.getCell("J6").value = { formula: "J4+J5" };
      ws.getCell("K6").value = { formula: "K4+K5" };
      ws.getCell("L6").value = { formula: "L4+L5" };

      ws.getRow(3).height = 30;

      styleSummaryRange();
    }

    // ===================================================
    // 1) SATILABİLİR
    // ===================================================

    ws.mergeCells(rowCursor, 1, rowCursor, 7);
    const sBaslik = ws.getCell(rowCursor, 1);
    const satilabilirBaslikRow = rowCursor;

    sBaslik.value = "SATILABİLİR STOK";
    sBaslik.font = { bold: true, size: 13 };
    sBaslik.alignment = { horizontal: "center" };
    sBaslik.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFF00" },
    };
    sBaslik.border = {
      top: { style: "thick" },
      bottom: { style: "thick" },
      left: { style: "thick" },
      right: { style: "thick" },
    };

    ws.getRow(rowCursor).height = 30;
    rowCursor++;

    writeHeader();

    const satilabilirHeaderRow = ws.lastRow.number;
    const satilabilirStartRow = satilabilirHeaderRow + 1;

    const toplamSatirlari = [];

    function writeSatilabilir(detay, tip) {
      const order = [
        "CR",
        "GR",
        "FH",
        "ZM",
        "HR",
        "ASITLI",
        "SOGUK ASITLI FIRIN",
      ];

      // BU GRUP İÇİN BAŞLANGIÇ
      const dataStartRow = ws.lastRow.number + 1;

      const sortedKeys = Object.keys(detay).sort((a, b) => {
        const aIndex = order.indexOf(a);
        const bIndex = order.indexOf(b);
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return a.localeCompare(b);
      });

      sortedKeys.forEach((cins) => {
        const r = ws.addRow(["", "", cins, tip, detay[cins], "", ""]);

        const stokSummaryGroup = getStokSummaryGroup(cins, tip);

        if (stokSummaryGroup) {
          tonajSummaryRows.stok[stokSummaryGroup].push(r.number);
        }

        r.getCell(5).numFmt = "0";

        r.eachCell((c) => {
          c.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
            bottom: { style: "thin" },
          };
        });

        // HYPERLINK
        let targetSheet = "";
        const type = tip.toUpperCase();
        const c = cins.toUpperCase();

        if (type === "RULO") {
          if (cins === "ASITLI") {
            targetSheet = "RULO ASİTLİ";
          } else if (cins === "SOGUK ASITLI FIRIN") {
            targetSheet = "RULO SOĞUK ASİTLİ FIRIN";
          } else if (cins === "FH FIRIN (CFF)") {
            targetSheet = "RULO SOĞUK FULLHARD FIRIN";
          } else if (cins === "FH SKINPASS (CRSF)") {
            targetSheet = "RULO SOĞUK FULLHARD SKINPASS";
          } else if (cins === "GALVANIZ HADDE") {
            targetSheet = "RULO GALVANİZ HADDE";
          } else if (cins === "ZM") {
            targetSheet = "MAGNELIS RULO STOK";
          } else if (cins === "FH SKINPASS(CRSF)") {
            targetSheet = "RULO SOĞUK FULLHARD SKİNPASS";
          } else {
            targetSheet = `${c} RULO STOK`;
          }
        } else if (type === "BAND") {
          if (cins === "CR HADDE (BCD)") {
            targetSheet = "BAND SOĞUK HADDE";
          } else if (cins === "FH FIRIN (BCFF)") {
            targetSheet = "BAND SOĞUK FULLHARD FIRIN";
          } else if (cins === "FH SKINPASS (BCRSF)") {
            targetSheet = "BAND SOĞUK FULLHARD SKİNPASS";
          } else if (cins === "GALVANIZ HADDE") {
            targetSheet = "BAND GALVANİZ HADDE";
          } else if (cins === "ZM") {
            targetSheet = "MAGNELIS BAND STOK";
          } else {
            targetSheet = `${c} BAND STOK`;
          }
        } else if (type === "BORU-PRF") {
          targetSheet = `${c} STOK BP`;
        }

        if (!targetSheet) targetSheet = `${c} STOK`;

        const link = `#'${targetSheet}'!A1`;

        ["C", "D"].forEach((col) => {
          const cell = r.getCell(col);
          cell.value = { text: String(cell.value), hyperlink: link };
          cell.font = { color: { argb: "FF000000" }, underline: true };
        });
      });

      // BU GRUP SON SATIR
      const dataEndRow = ws.lastRow.number;

      // FORMÜL
      const toplamFormula = `SUM(E${dataStartRow}:E${dataEndRow})`;

      const t = ws.addRow([
        "",
        "",
        "",
        "TOPLAM",
        { formula: toplamFormula },
        "",
        "",
      ]);
      t.getCell(4).font = { bold: true, color: { argb: "FF00B050" } };
      t.getCell(5).font = { bold: true, color: { argb: "FF00B050" } };
      t.getCell(5).numFmt = "0";

      t.eachCell((c) => {
        c.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
          bottom: { style: "thin" },
        };
      });

      //  BU TOPLAM SATIRINI KAYDET
      toplamSatirlari.push(ws.lastRow.number);
    }

    // YAZDIR
    writeSatilabilir(satilabilirAnaliz.rulo.detay, "RULO");
    writeSatilabilir(satilabilirAnaliz.band.detay, "BAND");
    writeSatilabilir(satilabilirAnaliz.profil.detay, "BORU-PRF");

    // ======================================================
    //  GENEL T. → FORMÜLLE OTOMATİK HESAPLANAN SÜRÜM
    // ======================================================

    const genelToplamFormula = toplamSatirlari
      .map((row) => `E${row}`)
      .join("+");

    const g = ws.addRow([
      "",
      "",
      "",
      "GENEL TOPLAM",
      { formula: genelToplamFormula },
      "",
      "",
    ]);

    g.getCell(4).font = { bold: true, color: { argb: "FFFF0000" } };
    g.getCell(5).font = { bold: true, color: { argb: "FFFF0000" } };
    g.getCell(5).numFmt = "0";

    g.eachCell((c) => {
      c.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
      };
    });

    const satilabilirEndRow = ws.lastRow.number;

    applyHeaderThick(ws, satilabilirHeaderRow, 7);
    applyDataSideBorders(ws, satilabilirStartRow, satilabilirEndRow, 7);

    // =======================================================================
    // GELECEK
    // =======================================================================

    rowCursor = ws.lastRow.number + 1;
    ws.mergeCells(rowCursor, 1, rowCursor, 7);

    const gBaslik = ws.getCell(rowCursor, 1);
    const gelecekBaslikRow = rowCursor;
    gBaslik.value = "GELECEK";
    gBaslik.font = { bold: true, size: 13 };
    gBaslik.alignment = { horizontal: "center" };
    gBaslik.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFF00" },
    };
    gBaslik.border = {
      top: { style: "thick" },
      bottom: { style: "thick" },
      left: { style: "thick" },
      right: { style: "thick" },
    };
    ws.getRow(rowCursor).height = 30; // UPDATED

    rowCursor++;
    writeHeader();

    const gelecekHeaderRow = ws.lastRow.number;
    const gelecekStartRow = gelecekHeaderRow + 1;

    hammaddeGelecek.sort((a, b) => {
      const order = { CR: 1, GR: 2, FH: 3 };
      const aCins = (a.cins || "").toUpperCase();
      const bCins = (b.cins || "").toUpperCase();
      return (order[aCins] || 99) - (order[bCins] || 99);
    });

    hammaddeGelecek.forEach((row) => {
      const r = ws.addRow([
        row.kontratNo,
        row.mensei,
        row.cins,
        row.tip,
        row.toplamKg,
        row.satis || "",
        "",
      ]);

      // SATIŞ = GELECEK sheet REZERV toplamı, MİKTAR = toplam - SATIŞ
      // (GELECEK sheet'leri sonra oluştuğu için linkAnaSatisToGelecek bağlar)
      kalinlikKirilimiRefs.anaGelecek.push({
        row: r.number,
        toplam: row.toplamKg,
        key: anaGelecekKey(row.kontratNo, row.mensei, row.cins, row.tip),
      });

      const gelecekSummaryGroup = getGelecekSummaryGroup(row.cins);

      if (gelecekSummaryGroup) {
        tonajSummaryRows.gelecek[gelecekSummaryGroup].push(r.number);
      }

      r.eachCell((c) => {
        c.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
          bottom: { style: "thin" },
        };
      });

      // === KÖPRÜ EKLEME ===
      const cins = (row.cins || "").toUpperCase();
      const targetSheet = `${cins} GELECEK`;
      const link = `#'${targetSheet}'!A1`;

      ["A", "B", "C", "D"].forEach((col) => {
        const cell = r.getCell(col);
        cell.value = {
          text: String(cell.value),
          hyperlink: link,
        };
        cell.font = {
          color: { argb: "FF000000" },
          underline: true,
        };
      });

      // === RENK (CINS BAZLI) ===
      const cell = r.getCell(3);
      if (cins === "CR")
        cell.font = {
          ...cell.font,
          bold: true,
          color: { argb: "FF0070C0" },
        };
      if (cins === "GR")
        cell.font = {
          ...cell.font,
          bold: true,
          color: { argb: "FF7F7F7F" },
        };
      if (cins === "FH")
        cell.font = {
          ...cell.font,
          bold: true,
          color: { argb: "FFFF0000" },
        };
      if (cins === "HR")
        cell.font = {
          ...cell.font,
          bold: true,
          color: { argb: "FFA500" },
        };
    });

    const endRow = ws.lastRow.number;

    // 1) TOPLAM (Gelecek Miktar Toplamı: E Kolonu)
    const toplamSatir = ws.addRow([
      "",
      "",
      "",
      "",
      "SATILABİLİR",
      { formula: `SUM(E${gelecekStartRow}:E${endRow})` },
      "",
    ]);
    toplamSatir.getCell(5).font = { bold: true, color: { argb: "FF00B050" } };
    toplamSatir.getCell(6).font = { bold: true, color: { argb: "FF00B050" } };
    toplamSatir.eachCell((c) => {
      c.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
      };
    });

    // 2) SATILAN (Satışların Toplamı: F Kolonu)
    const satilanSatir = ws.addRow([
      "",
      "",
      "",
      "",
      "SATILAN",
      { formula: `SUM(F${gelecekStartRow}:F${endRow})` },
      "",
    ]);
    satilanSatir.getCell(5).font = { bold: true, color: { argb: "0000FF" } };
    satilanSatir.getCell(6).font = { bold: true, color: { argb: "0000FF" } };
    satilanSatir.eachCell((c) => {
      c.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
      };
    });

    // 3) GENEL T. (Kalan Miktar = TOPLAM - SATILAN)
    const genelSatir = ws.addRow([
      "",
      "",
      "",
      "",
      "GENEL TOPLAM",
      { formula: `F${toplamSatir.number} + F${satilanSatir.number}` },
      "",
    ]);
    genelSatir.getCell(5).font = { bold: true, color: { argb: "FFFF0000" } };
    genelSatir.getCell(6).font = { bold: true, color: { argb: "FFFF0000" } };
    genelSatir.eachCell((c) => {
      c.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
      };
    });

    const gelecekEndRow = ws.lastRow.number;

    applyHeaderThick(ws, gelecekHeaderRow, 7);
    applyDataSideBorders(ws, gelecekStartRow, gelecekEndRow, 7);

    writeTonajSummaryTable();

    // === TÜM SATIR YÜKSEKLİĞİ 17 ===
    ws.eachRow((row) => {
      row.height = 17;
    });

    ws.eachRow((row, rowNumber) => {
      const rows30 = [
        1, // Büyük başlık
        satilabilirBaslikRow, // SATILABİLİR STOK başlığı
        satilabilirHeaderRow, // SATILABİLİR kolon header
        gelecekBaslikRow, // GELECEK başlığı
        gelecekHeaderRow, // GELECEK kolon header
        3, // sağ özet tablo başlığı
      ];

      if (rows30.includes(rowNumber)) {
        row.height = 30;
      } else {
        row.height = 17;
      }
    });

    applyCenterAlignment(ws);
    applyGlobalFont(ws);
  }

  function analizCrGrRulo(rulo = [], hammadde = []) {
    const result = { SOĞUK: {}, GALVANİZ: {}, FULLHARD: {}, SICAK: {} };
    const groups = ["SOĞUK", "GALVANİZ", "FULLHARD", "SICAK"];

    groups.forEach((tur) => {
      const filteredRulo = rulo.filter((x) => x.Tür === tur);

      filteredRulo.forEach((row) => {
        const kalinlik = Number(String(row.Kalınlık).replace(",", "."));
        const kg = Number(row.ToplamKg) || 0;

        if (!result[tur][kalinlik]) {
          result[tur][kalinlik] = {
            kalinlik,
            stok: 0,
            stokOpsiyonlu: 0,
            stokSatilabilir: 0,
            gelecek: 0,
            gelecekOpsiyonlu: 0,
            gelecekSatilabilir: 0,
            toplamOpsiyonlu: 0,
            toplamSatilabilir: 0,
          };
        }

        const target = result[tur][kalinlik];
        target.stok += kg;

        const is1Kalite = row["Cari Ünvanı"] === "--1. KALİTE ÜRETİM STOK--";
        if (!is1Kalite) target.stokOpsiyonlu += kg;
      });

      const filteredHam = hammadde.filter((x) => x.Cins2 === tur);

      filteredHam.forEach((row) => {
        const kalinlik = Number(String(row.kalinlik).replace(",", "."));
        const kg = Number(row.ToplamKg) || Number(row.tonaj) || 0;

        if (!result[tur][kalinlik]) {
          result[tur][kalinlik] = {
            kalinlik,
            stok: 0,
            stokOpsiyonlu: 0,
            stokSatilabilir: 0,
            gelecek: 0,
            gelecekOpsiyonlu: 0,
            gelecekSatilabilir: 0,
            toplamOpsiyonlu: 0,
            toplamSatilabilir: 0,
          };
        }

        const target = result[tur][kalinlik];
        target.gelecek += kg;
        target.gelecekSatilabilir += kg;
      });

      Object.values(result[tur]).forEach((x) => {
        x.stokSatilabilir = x.stok - x.stokOpsiyonlu;
        x.gelecekOpsiyonlu = 0;
        x.gelecekSatilabilir = x.gelecek;

        x.toplamOpsiyonlu = x.stokOpsiyonlu;
        x.toplamSatilabilir = x.stokSatilabilir + x.gelecekSatilabilir;
      });

      result[tur] = Object.values(result[tur]).sort(
        (a, b) => b.kalinlik - a.kalinlik
      );
    });

    return result;
  }

  function createCrGrSheet(analiz) {
    const ws = wb.addWorksheet("KALINLIK KIRILIMI");
    kalinlikKirilimiRefs.ws = ws;

    ws.columns = [
      { width: 25 },
      { width: 20 },
      { width: 22 },
      { width: 25 },
      { width: 20 },
      { width: 22 },
      { width: 25 },
      { width: 22 },
      { width: 25 },
    ];

    const yellowFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFF00" },
    };

    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9D9D9" },
    };

    const titleColors = {
      CR: "FF00B0F0",
      GR: "FFBFBFBF",
      FULLHARD: "CC0000",
    };

    const headers = [
      "KALINLIK",
      "STOK",
      "STOK OPSİYONLU",
      "STOK SATILABİLİR",
      "GELECEK",
      "GELECEK OPSİYONLU",
      "GELECEK SATILABİLİR",
      "TOPLAM OPSİYONLU",
      "TOPLAM SATILABİLİR",
    ];

    let currentRow = 1;

    function writeTable(title, rows, color) {
      ws.mergeCells(currentRow, 1, currentRow, headers.length);

      const titleCell = ws.getCell(currentRow, 1);
      titleCell.value = title;
      titleCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: color },
      };
      titleCell.font = { size: 16, bold: true, color: { argb: "FFFFFFFF" } };
      titleCell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };

      for (let col = 1; col <= headers.length; col++) {
        ws.getCell(currentRow, col).border = {
          top: { style: "medium" },
          left: { style: "medium" },
          right: { style: "medium" },
          bottom: { style: "medium" },
        };
      }

      currentRow++;

      const hRow = ws.addRow(headers);
      const headerRowIndex = currentRow;

      hRow.eachCell((c, col) => {
        c.fill = headerFill;
        c.font = { bold: true };
        c.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true,
        };

        if (col === 4 || col === 7) {
          c.fill = yellowFill;
        }

        c.border = {
          top: { style: "medium" },
          left: { style: "medium" },
          right: { style: "medium" },
          bottom: { style: "medium" },
        };
      });

      currentRow++;

      const dataStart = currentRow;

      rows.forEach((r) => {
        const row = ws.addRow([
          r.kalinlik, // A
          r.stok, // B
          r.stokOpsiyonlu, // C
          r.stokSatilabilir, // D
          r.gelecek, // E
          r.gelecekOpsiyonlu, // F
          null, // G = formül
          null, // H = formül
          null, // I = formül
        ]);

        const rowNum = row.number;

        // F (GELECEK OPSİYONLU) → sonra GELECEK REZERV formülüne bağlanacak
        if (kalinlikKirilimiRefs.rows[title]) {
          kalinlikKirilimiRefs.rows[title][kalinlikKey(r.kalinlik)] = rowNum;
        }

        // G = GELECEK SATILABİLİR = E - F
        row.getCell(7).value = {
          formula: `E${rowNum}-F${rowNum}`,
        };

        // H = TOPLAM OPSİYONLU = C + F
        row.getCell(8).value = {
          formula: `C${rowNum}+F${rowNum}`,
        };

        // I = TOPLAM SATILABİLİR = D + G
        row.getCell(9).value = {
          formula: `D${rowNum}+G${rowNum}`,
        };

        row.eachCell((c, col) => {
          if (col === 4 || col === 7) {
            c.fill = yellowFill;
          }

          if (col >= 2 && col <= 9) {
            c.numFmt = "#,##0";
          }

          c.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };

          c.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
            bottom: { style: "thin" },
          };
        });

        currentRow++;
      });

      const totalRow = ws.addRow([
        "TOPLAM",
        { formula: `SUM(B${dataStart}:B${currentRow - 1})` },
        { formula: `SUM(C${dataStart}:C${currentRow - 1})` },
        { formula: `SUM(D${dataStart}:D${currentRow - 1})` },
        { formula: `SUM(E${dataStart}:E${currentRow - 1})` },
        { formula: `SUM(F${dataStart}:F${currentRow - 1})` },
        { formula: `SUM(G${dataStart}:G${currentRow - 1})` },
        { formula: `SUM(H${dataStart}:H${currentRow - 1})` },
        { formula: `SUM(I${dataStart}:I${currentRow - 1})` },
      ]);

      const dataEnd = currentRow;

      totalRow.eachCell((c, col) => {
        if (col === 4 || col === 7) {
          c.fill = yellowFill;
        }

        if (col >= 2 && col <= 9) {
          c.numFmt = "#,##0";
          c.font = { bold: true };
        }

        if (col === 1) {
          c.font = { bold: true };
        }

        c.alignment = { horizontal: "center", vertical: "middle" };

        c.border = {
          top: { style: "medium" },
          left: { style: "medium" },
          right: { style: "medium" },
          bottom: { style: "medium" },
        };
      });

      applyHeaderThick(ws, headerRowIndex, headers.length);
      applyDataSideBorders(ws, dataStart, dataEnd, headers.length);

      currentRow += 3;
    }

    writeTable("CR", analiz.SOĞUK, titleColors.CR);
    writeTable("GR", analiz.GALVANİZ, titleColors.GR);
    writeTable("FULLHARD", analiz.FULLHARD, titleColors.FULLHARD);

    applyGlobalFontForGenel(ws);
  }

  createGroupedSheets();

  const buf = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    }),
    `GÖKTAŞ STOK DURUM RAPORU_${new Date()
      .toLocaleDateString("tr-TR")
      .split(".")
      .join("-")}.xlsx`
  );
}
